var Ae = Object.defineProperty;
var Ue = (c, u, h) => u in c ? Ae(c, u, { enumerable: !0, configurable: !0, writable: !0, value: h }) : c[u] = h;
var O = (c, u, h) => Ue(c, typeof u != "symbol" ? u + "" : u, h);
import { renderIcon as Ne, renderSuggestion as je } from "./-search-form.js";
import { d as Ge, O as _e } from "./chunk-debounce-Bk6yKvzA.js";
function Oe(c, u) {
  const h = "https://example.com", g = "https://www.watchesofswitzerland.com/cdn/shop/", q = /https:\/\/cdn\.shopify\.com\/s\/files\/[^files|collections|articles]+/;
  return c.match(q) ? new URL(c.replace(q, g), h).toString().replace(h, "") : c;
}
function D() {
  function c(u) {
    return new Promise((h) => {
      let m = new XMLHttpRequest();
      m.open(u.method, u.url, !0), Object.keys(u.headers).forEach((t) => m.setRequestHeader(t, u.headers[t]));
      let g = (t, e) => setTimeout(() => {
        m.abort(), h({ status: 0, content: e, isTimedOut: !0 });
      }, t), q = g(u.connectTimeout, "Connection timeout"), l;
      m.onreadystatechange = () => {
        m.readyState > m.OPENED && l === void 0 && (clearTimeout(q), l = g(u.responseTimeout, "Socket timeout"));
      }, m.onerror = () => {
        m.status === 0 && (clearTimeout(q), clearTimeout(l), h({ content: m.responseText || "Network request failed", status: m.status, isTimedOut: !1 }));
      }, m.onload = () => {
        clearTimeout(q), clearTimeout(l), h({ content: m.responseText, status: m.status, isTimedOut: !1 });
      }, m.send(u.data);
    });
  }
  return { send: c };
}
function R(c) {
  let u;
  const h = `algolia-client-js-${c.key}`;
  function m() {
    return u === void 0 && (u = c.localStorage || window.localStorage), u;
  }
  function g() {
    return JSON.parse(m().getItem(h) || "{}");
  }
  function q(t) {
    m().setItem(h, JSON.stringify(t));
  }
  function l() {
    const t = c.timeToLive ? c.timeToLive * 1e3 : null, e = g(), r = Object.fromEntries(
      Object.entries(e).filter(([, s]) => s.timestamp !== void 0)
    );
    if (q(r), !t)
      return;
    const a = Object.fromEntries(
      Object.entries(r).filter(([, s]) => {
        const o = (/* @__PURE__ */ new Date()).getTime();
        return !(s.timestamp + t < o);
      })
    );
    q(a);
  }
  return {
    get(t, e, r = {
      miss: () => Promise.resolve()
    }) {
      return Promise.resolve().then(() => (l(), g()[JSON.stringify(t)])).then((a) => Promise.all([a ? a.value : e(), a !== void 0])).then(([a, s]) => Promise.all([a, s || r.miss(a)])).then(([a]) => a);
    },
    set(t, e) {
      return Promise.resolve().then(() => {
        const r = g();
        return r[JSON.stringify(t)] = {
          timestamp: (/* @__PURE__ */ new Date()).getTime(),
          value: e
        }, m().setItem(h, JSON.stringify(r)), e;
      });
    },
    delete(t) {
      return Promise.resolve().then(() => {
        const e = g();
        delete e[JSON.stringify(t)], m().setItem(h, JSON.stringify(e));
      });
    },
    clear() {
      return Promise.resolve().then(() => {
        m().removeItem(h);
      });
    }
  };
}
function $e() {
  return {
    get(c, u, h = {
      miss: () => Promise.resolve()
    }) {
      return u().then((g) => Promise.all([g, h.miss(g)])).then(([g]) => g);
    },
    set(c, u) {
      return Promise.resolve(u);
    },
    delete(c) {
      return Promise.resolve();
    },
    clear() {
      return Promise.resolve();
    }
  };
}
function b(c) {
  const u = [...c.caches], h = u.shift();
  return h === void 0 ? $e() : {
    get(m, g, q = {
      miss: () => Promise.resolve()
    }) {
      return h.get(m, g, q).catch(() => b({ caches: u }).get(m, g, q));
    },
    set(m, g) {
      return h.set(m, g).catch(() => b({ caches: u }).set(m, g));
    },
    delete(m) {
      return h.delete(m).catch(() => b({ caches: u }).delete(m));
    },
    clear() {
      return h.clear().catch(() => b({ caches: u }).clear());
    }
  };
}
function E(c = { serializable: !0 }) {
  let u = {};
  return {
    get(h, m, g = {
      miss: () => Promise.resolve()
    }) {
      const q = JSON.stringify(h);
      if (q in u)
        return Promise.resolve(c.serializable ? JSON.parse(u[q]) : u[q]);
      const l = m();
      return l.then((t) => g.miss(t)).then(() => l);
    },
    set(h, m) {
      return u[JSON.stringify(h)] = c.serializable ? JSON.stringify(m) : m, Promise.resolve(m);
    },
    delete(h) {
      return delete u[JSON.stringify(h)], Promise.resolve();
    },
    clear() {
      return u = {}, Promise.resolve();
    }
  };
}
function Be(c) {
  const u = {
    value: `Algolia for JavaScript (${c})`,
    add(h) {
      const m = `; ${h.segment}${h.version !== void 0 ? ` (${h.version})` : ""}`;
      return u.value.indexOf(m) === -1 && (u.value = `${u.value}${m}`), u;
    }
  };
  return u;
}
function k(c, u, h = "WithinHeaders") {
  const m = {
    "x-algolia-api-key": u,
    "x-algolia-application-id": c
  };
  return {
    headers() {
      return h === "WithinHeaders" ? m : {};
    },
    queryParameters() {
      return h === "WithinQueryParameters" ? m : {};
    }
  };
}
function G({
  func: c,
  validate: u,
  aggregator: h,
  error: m,
  timeout: g = () => 0
}) {
  const q = (l) => new Promise((t, e) => {
    c(l).then(async (r) => (h && await h(r), await u(r) ? t(r) : m && await m.validate(r) ? e(new Error(await m.message(r))) : setTimeout(
      () => {
        q(r).then(t).catch(e);
      },
      await g()
    ))).catch((r) => {
      e(r);
    });
  });
  return q();
}
function x({ algoliaAgents: c, client: u, version: h }) {
  const m = Be(h).add({
    segment: u,
    version: h
  });
  return c.forEach((g) => m.add(g)), m;
}
function A() {
  return {
    debug(c, u) {
      return Promise.resolve();
    },
    info(c, u) {
      return Promise.resolve();
    },
    error(c, u) {
      return Promise.resolve();
    }
  };
}
var oe = 120 * 1e3;
function ie(c, u = "up") {
  const h = Date.now();
  function m() {
    return u === "up" || Date.now() - h > oe;
  }
  function g() {
    return u === "timed out" && Date.now() - h <= oe;
  }
  return { ...c, status: u, lastUpdate: h, isUp: m, isTimedOut: g };
}
var Pe = class extends Error {
  constructor(u, h) {
    super(u);
    O(this, "name", "AlgoliaError");
    h && (this.name = h);
  }
}, ge = class extends Pe {
  constructor(u, h, m) {
    super(u, m);
    O(this, "stackTrace");
    this.stackTrace = h;
  }
}, He = class extends ge {
  constructor(c) {
    super(
      "Unreachable hosts - your application id may be incorrect. If the error persists, please visit our help center https://alg.li/support-unreachable-hosts or reach out to the Algolia Support team: https://alg.li/support",
      c,
      "RetryError"
    );
  }
}, H = class extends ge {
  constructor(u, h, m, g = "ApiError") {
    super(u, m, g);
    O(this, "status");
    this.status = h;
  }
}, Le = class extends Pe {
  constructor(u, h) {
    super(u, "DeserializationError");
    O(this, "response");
    this.response = h;
  }
}, ze = class extends H {
  constructor(u, h, m, g) {
    super(u, h, g, "DetailedApiError");
    O(this, "error");
    this.error = m;
  }
};
function we(c) {
  const u = c;
  for (let h = c.length - 1; h > 0; h--) {
    const m = Math.floor(Math.random() * (h + 1)), g = c[h];
    u[h] = c[m], u[m] = g;
  }
  return u;
}
function Ve(c, u, h) {
  const m = We(h);
  let g = `${c.protocol}://${c.url}${c.port ? `:${c.port}` : ""}/${u.charAt(0) === "/" ? u.substring(1) : u}`;
  return m.length && (g += `?${m}`), g;
}
function We(c) {
  return Object.keys(c).filter((u) => c[u] !== void 0).sort().map(
    (u) => `${u}=${encodeURIComponent(
      Object.prototype.toString.call(c[u]) === "[object Array]" ? c[u].join(",") : c[u]
    ).replace(/\+/g, "%20")}`
  ).join("&");
}
function Qe(c, u) {
  if (c.method === "GET" || c.data === void 0 && u.data === void 0)
    return;
  const h = Array.isArray(c.data) ? c.data : { ...c.data, ...u.data };
  return JSON.stringify(h);
}
function Fe(c, u, h) {
  const m = {
    Accept: "application/json",
    ...c,
    ...u,
    ...h
  }, g = {};
  return Object.keys(m).forEach((q) => {
    const l = m[q];
    g[q.toLowerCase()] = l;
  }), g;
}
function Me(c) {
  try {
    return JSON.parse(c.content);
  } catch (u) {
    throw new Le(u.message, c);
  }
}
function Je({ content: c, status: u }, h) {
  try {
    const m = JSON.parse(c);
    return "error" in m ? new ze(m.message, u, m.error, h) : new H(m.message, u, h);
  } catch {
  }
  return new H(c, u, h);
}
function Ke({ isTimedOut: c, status: u }) {
  return !c && ~~u === 0;
}
function Xe({ isTimedOut: c, status: u }) {
  return c || Ke({ isTimedOut: c, status: u }) || ~~(u / 100) !== 2 && ~~(u / 100) !== 4;
}
function Ye({ status: c }) {
  return ~~(c / 100) === 2;
}
function Ze(c) {
  return c.map((u) => fe(u));
}
function fe(c) {
  const u = c.request.headers["x-algolia-api-key"] ? { "x-algolia-api-key": "*****" } : {};
  return {
    ...c,
    request: {
      ...c.request,
      headers: {
        ...c.request.headers,
        ...u
      }
    }
  };
}
function U({
  hosts: c,
  hostsCache: u,
  baseHeaders: h,
  logger: m,
  baseQueryParameters: g,
  algoliaAgent: q,
  timeouts: l,
  requester: t,
  requestsCache: e,
  responsesCache: r
}) {
  async function a(n) {
    const i = await Promise.all(
      n.map((y) => u.get(y, () => Promise.resolve(ie(y))))
    ), d = i.filter((y) => y.isUp()), P = i.filter((y) => y.isTimedOut()), w = [...d, ...P];
    return {
      hosts: w.length > 0 ? w : n,
      getTimeout(y, p) {
        return (P.length === 0 && y === 0 ? 1 : P.length + 3 + y) * p;
      }
    };
  }
  async function s(n, i, d = !0) {
    const P = [], w = Qe(n, i), f = Fe(h, n.headers, i.headers), y = n.method === "GET" ? {
      ...n.data,
      ...i.data
    } : {}, p = {
      ...g,
      ...n.queryParameters,
      ...y
    };
    if (q.value && (p["x-algolia-agent"] = q.value), i && i.queryParameters)
      for (const T of Object.keys(i.queryParameters))
        !i.queryParameters[T] || Object.prototype.toString.call(i.queryParameters[T]) === "[object Object]" ? p[T] = i.queryParameters[T] : p[T] = i.queryParameters[T].toString();
    let v = 0;
    const S = async (T, L) => {
      const $ = T.pop();
      if ($ === void 0)
        throw new He(Ze(P));
      const z = { ...l, ...i.timeouts }, ae = {
        data: w,
        headers: f,
        method: n.method,
        url: Ve($, n.path, p),
        connectTimeout: L(v, z.connect),
        responseTimeout: L(v, d ? z.read : z.write)
      }, se = (V) => {
        const ne = {
          request: ae,
          response: V,
          host: $,
          triesLeft: T.length
        };
        return P.push(ne), ne;
      }, j = await t.send(ae);
      if (Xe(j)) {
        const V = se(j);
        return j.isTimedOut && v++, m.info("Retryable failure", fe(V)), await u.set($, ie($, j.isTimedOut ? "timed out" : "down")), S(T, L);
      }
      if (Ye(j))
        return Me(j);
      throw se(j), Je(j, P);
    }, N = c.filter(
      (T) => T.accept === "readWrite" || (d ? T.accept === "read" : T.accept === "write")
    ), _ = await a(N);
    return S([..._.hosts].reverse(), _.getTimeout);
  }
  function o(n, i = {}) {
    const d = n.useReadTransporter || n.method === "GET";
    if (!d)
      return s(n, i, d);
    const P = () => s(n, i);
    if ((i.cacheable || n.cacheable) !== !0)
      return P();
    const f = {
      request: n,
      requestOptions: i,
      transporter: {
        queryParameters: g,
        headers: h
      }
    };
    return r.get(
      f,
      () => e.get(
        f,
        () => (
          /**
           * Finally, if there is no request in progress with the same key,
           * this `createRetryableRequest()` will actually trigger the
           * retryable request.
           */
          e.set(f, P()).then(
            (y) => Promise.all([e.delete(f), y]),
            (y) => Promise.all([e.delete(f), Promise.reject(y)])
          ).then(([y, p]) => p)
        )
      ),
      {
        /**
         * Of course, once we get this response back from the server, we
         * tell response cache to actually store the received response
         * to be used later.
         */
        miss: (y) => r.set(f, y)
      }
    );
  }
  return {
    hostsCache: u,
    requester: t,
    timeouts: l,
    logger: m,
    algoliaAgent: q,
    baseHeaders: h,
    baseQueryParameters: g,
    hosts: c,
    request: o,
    requestsCache: e,
    responsesCache: r
  };
}
var F = "1.10.0", ue = ["de", "us"];
function er(c) {
  return [{ url: c ? "analytics.{region}.algolia.com".replace("{region}", c) : "analytics.algolia.com", accept: "readWrite", protocol: "https" }];
}
function rr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  region: g,
  ...q
}) {
  const l = k(c, u, h), t = U({
    hosts: er(g),
    ...q,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "AbtestingV3",
      version: F
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...l.headers(),
      ...q.baseHeaders
    },
    baseQueryParameters: {
      ...l.queryParameters(),
      ...q.baseQueryParameters
    }
  });
  return {
    transporter: t,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([t.requestsCache.clear(), t.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return t.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, r) {
      t.algoliaAgent.add({ segment: e, version: r });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !h || h === "WithinHeaders" ? t.baseHeaders["x-algolia-api-key"] = e : t.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * Creates a new A/B test.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param addABTestsRequest - The addABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    addABTests(e, r) {
      if (!e)
        throw new Error("Parameter `addABTestsRequest` is required when calling `addABTests`.");
      if (!e.name)
        throw new Error("Parameter `addABTestsRequest.name` is required when calling `addABTests`.");
      if (!e.variants)
        throw new Error("Parameter `addABTestsRequest.variants` is required when calling `addABTests`.");
      if (!e.metrics)
        throw new Error("Parameter `addABTestsRequest.metrics` is required when calling `addABTests`.");
      if (!e.endAt)
        throw new Error("Parameter `addABTestsRequest.endAt` is required when calling `addABTests`.");
      const n = {
        method: "POST",
        path: "/3/abtests",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const i = {
        method: "DELETE",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const i = {
        method: "GET",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const d = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const d = {
        method: "PUT",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * Deletes an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteABTest - The deleteABTest object.
     * @param deleteABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteABTest({ id: e }, r) {
      if (!e)
        throw new Error("Parameter `id` is required when calling `deleteABTest`.");
      const n = {
        method: "DELETE",
        path: "/3/abtests/{id}".replace("{id}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Given the traffic percentage and the expected effect size, this endpoint estimates the sample size and duration of an A/B test based on historical traffic.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param estimateABTestRequest - The estimateABTestRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    estimateABTest(e, r) {
      if (!e)
        throw new Error("Parameter `estimateABTestRequest` is required when calling `estimateABTest`.");
      if (!e.configuration)
        throw new Error("Parameter `estimateABTestRequest.configuration` is required when calling `estimateABTest`.");
      if (!e.variants)
        throw new Error("Parameter `estimateABTestRequest.variants` is required when calling `estimateABTest`.");
      const n = {
        method: "POST",
        path: "/3/abtests/estimate",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Retrieves the details for an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getABTest - The getABTest object.
     * @param getABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getABTest({ id: e }, r) {
      if (!e)
        throw new Error("Parameter `id` is required when calling `getABTest`.");
      const n = {
        method: "GET",
        path: "/3/abtests/{id}".replace("{id}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves timeseries for an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTimeseries - The getTimeseries object.
     * @param getTimeseries.id - Unique A/B test identifier.
     * @param getTimeseries.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTimeseries.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTimeseries.metric - List of metrics to retrieve. If not specified, all metrics are returned.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTimeseries({ id: e, startDate: r, endDate: a, metric: s }, o) {
      if (!e)
        throw new Error("Parameter `id` is required when calling `getTimeseries`.");
      const n = "/3/abtests/{id}/timeseries".replace("{id}", encodeURIComponent(e)), i = {}, d = {};
      r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.metric = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Lists all A/B tests you configured for this application.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param listABTests - The listABTests object.
     * @param listABTests.offset - Position of the first item to return.
     * @param listABTests.limit - Number of items to return.
     * @param listABTests.indexPrefix - Index name prefix. Only A/B tests for indices starting with this string are included in the response.
     * @param listABTests.indexSuffix - Index name suffix. Only A/B tests for indices ending with this string are included in the response.
     * @param listABTests.direction - Sort order for A/B tests by start date. Use \'asc\' for ascending or \'desc\' for descending. Active A/B tests are always listed first.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listABTests({ offset: e, limit: r, indexPrefix: a, indexSuffix: s, direction: o } = {}, n = void 0) {
      const i = "/3/abtests", d = {}, P = {};
      e !== void 0 && (P.offset = e.toString()), r !== void 0 && (P.limit = r.toString()), a !== void 0 && (P.indexPrefix = a.toString()), s !== void 0 && (P.indexSuffix = s.toString()), o !== void 0 && (P.direction = o.toString());
      const w = {
        method: "GET",
        path: i,
        queryParameters: P,
        headers: d
      };
      return t.request(w, n);
    },
    /**
     * Stops an A/B test by its ID.  You can\'t restart stopped A/B tests.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param stopABTest - The stopABTest object.
     * @param stopABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    stopABTest({ id: e }, r) {
      if (!e)
        throw new Error("Parameter `id` is required when calling `stopABTest`.");
      const n = {
        method: "POST",
        path: "/3/abtests/{id}/stop".replace("{id}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    }
  };
}
function pe(c, u, h, m) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  if (h && (typeof h != "string" || !ue.includes(h)))
    throw new Error(`\`region\` must be one of the following: ${ue.join(", ")}`);
  return rr({
    appId: c,
    apiKey: u,
    region: h,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${F}-${c}` }), E()]
    }),
    ...m
  });
}
const tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abtestingV3Client: pe,
  apiClientVersion: F
}, Symbol.toStringTag, { value: "Module" }));
var M = "5.44.0", ce = ["de", "us"];
function ar(c) {
  return [{ url: c ? "analytics.{region}.algolia.com".replace("{region}", c) : "analytics.algolia.com", accept: "readWrite", protocol: "https" }];
}
function sr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  region: g,
  ...q
}) {
  const l = k(c, u, h), t = U({
    hosts: ar(g),
    ...q,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Abtesting",
      version: M
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...l.headers(),
      ...q.baseHeaders
    },
    baseQueryParameters: {
      ...l.queryParameters(),
      ...q.baseQueryParameters
    }
  });
  return {
    transporter: t,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([t.requestsCache.clear(), t.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return t.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, r) {
      t.algoliaAgent.add({ segment: e, version: r });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !h || h === "WithinHeaders" ? t.baseHeaders["x-algolia-api-key"] = e : t.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * Creates a new A/B test.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param addABTestsRequest - The addABTestsRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    addABTests(e, r) {
      if (!e)
        throw new Error("Parameter `addABTestsRequest` is required when calling `addABTests`.");
      if (!e.name)
        throw new Error("Parameter `addABTestsRequest.name` is required when calling `addABTests`.");
      if (!e.variants)
        throw new Error("Parameter `addABTestsRequest.variants` is required when calling `addABTests`.");
      if (!e.endAt)
        throw new Error("Parameter `addABTestsRequest.endAt` is required when calling `addABTests`.");
      const n = {
        method: "POST",
        path: "/2/abtests",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const i = {
        method: "DELETE",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const i = {
        method: "GET",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const d = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const d = {
        method: "PUT",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * Deletes an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteABTest - The deleteABTest object.
     * @param deleteABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteABTest({ id: e }, r) {
      if (!e)
        throw new Error("Parameter `id` is required when calling `deleteABTest`.");
      const n = {
        method: "DELETE",
        path: "/2/abtests/{id}".replace("{id}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Given the traffic percentage and the expected effect size, this endpoint estimates the sample size and duration of an A/B test based on historical traffic.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param estimateABTestRequest - The estimateABTestRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    estimateABTest(e, r) {
      if (!e)
        throw new Error("Parameter `estimateABTestRequest` is required when calling `estimateABTest`.");
      if (!e.configuration)
        throw new Error("Parameter `estimateABTestRequest.configuration` is required when calling `estimateABTest`.");
      if (!e.variants)
        throw new Error("Parameter `estimateABTestRequest.variants` is required when calling `estimateABTest`.");
      const n = {
        method: "POST",
        path: "/2/abtests/estimate",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Retrieves the details for an A/B test by its ID.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getABTest - The getABTest object.
     * @param getABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getABTest({ id: e }, r) {
      if (!e)
        throw new Error("Parameter `id` is required when calling `getABTest`.");
      const n = {
        method: "GET",
        path: "/2/abtests/{id}".replace("{id}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Lists all A/B tests you configured for this application.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param listABTests - The listABTests object.
     * @param listABTests.offset - Position of the first item to return.
     * @param listABTests.limit - Number of items to return.
     * @param listABTests.indexPrefix - Index name prefix. Only A/B tests for indices starting with this string are included in the response.
     * @param listABTests.indexSuffix - Index name suffix. Only A/B tests for indices ending with this string are included in the response.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listABTests({ offset: e, limit: r, indexPrefix: a, indexSuffix: s } = {}, o = void 0) {
      const n = "/2/abtests", i = {}, d = {};
      e !== void 0 && (d.offset = e.toString()), r !== void 0 && (d.limit = r.toString()), a !== void 0 && (d.indexPrefix = a.toString()), s !== void 0 && (d.indexSuffix = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Stops an A/B test by its ID.  You can\'t restart stopped A/B tests.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param stopABTest - The stopABTest object.
     * @param stopABTest.id - Unique A/B test identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    stopABTest({ id: e }, r) {
      if (!e)
        throw new Error("Parameter `id` is required when calling `stopABTest`.");
      const n = {
        method: "POST",
        path: "/2/abtests/{id}/stop".replace("{id}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    }
  };
}
function ye(c, u, h, m) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  if (h && (typeof h != "string" || !ce.includes(h)))
    throw new Error(`\`region\` must be one of the following: ${ce.join(", ")}`);
  return sr({
    appId: c,
    apiKey: u,
    region: h,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${M}-${c}` }), E()]
    }),
    ...m
  });
}
const nr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abtestingClient: ye,
  apiClientVersion: M
}, Symbol.toStringTag, { value: "Module" }));
var J = "5.44.0", he = ["de", "us"];
function or(c) {
  return [{ url: c ? "analytics.{region}.algolia.com".replace("{region}", c) : "analytics.algolia.com", accept: "readWrite", protocol: "https" }];
}
function ir({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  region: g,
  ...q
}) {
  const l = k(c, u, h), t = U({
    hosts: or(g),
    ...q,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Analytics",
      version: J
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...l.headers(),
      ...q.baseHeaders
    },
    baseQueryParameters: {
      ...l.queryParameters(),
      ...q.baseQueryParameters
    }
  });
  return {
    transporter: t,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([t.requestsCache.clear(), t.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return t.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, r) {
      t.algoliaAgent.add({ segment: e, version: r });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !h || h === "WithinHeaders" ? t.baseHeaders["x-algolia-api-key"] = e : t.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const i = {
        method: "DELETE",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const i = {
        method: "GET",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const d = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const d = {
        method: "PUT",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * Retrieves the add-to-cart rate for all your searches with at least one add-to-cart event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  The rate is the number of add-to-cart conversion events divided by the number of tracked searches. A search is tracked if it returns a queryID (`clickAnalytics` is `true`). This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`.  **There\'s a difference between a 0 and null add-to-cart rate when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the add-to-cart rate is null. - **0** mean there _were_ queries but no [add-to-cart events](https://www.algolia.com/doc/guides/sending-events/getting-started) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getAddToCartRate - The getAddToCartRate object.
     * @param getAddToCartRate.index - Index name.
     * @param getAddToCartRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAddToCartRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAddToCartRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getAddToCartRate({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getAddToCartRate`.");
      const n = "/2/conversions/addToCartRate", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the average click position of your search results, including a daily breakdown.  The average click position is the average of all clicked search result positions. For example, if users only ever click on the first result for any search, the average click position is 1. By default, the analyzed period includes the last eight days including the current day.  An average of `null` when `clickAnalytics` is enabled means Algolia didn\'t receive any [click events](https://www.algolia.com/doc/guides/sending-events/getting-started) for the queries. The average is `null` until Algolia receives at least one click event.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getAverageClickPosition - The getAverageClickPosition object.
     * @param getAverageClickPosition.index - Index name.
     * @param getAverageClickPosition.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAverageClickPosition.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getAverageClickPosition.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getAverageClickPosition({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getAverageClickPosition`.");
      const n = "/2/clicks/averageClickPosition", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the positions in the search results and their associated number of clicks.  This lets you check how many clicks the first, second, or tenth search results receive.  An average of `0` when `clickAnalytics` is enabled means Algolia didn\'t receive any [click events](https://www.algolia.com/doc/guides/sending-events/getting-started) for the queries.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getClickPositions - The getClickPositions object.
     * @param getClickPositions.index - Index name.
     * @param getClickPositions.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickPositions.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickPositions.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getClickPositions({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getClickPositions`.");
      const n = "/2/clicks/positions", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the click-through rate (CTR) for all your searches with at least one click event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  **There\'s a difference between a 0 and null CTR when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, CTR is null. - **0** mean there _were_ queries but no [click events](https://www.algolia.com/doc/guides/sending-events/getting-started) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getClickThroughRate - The getClickThroughRate object.
     * @param getClickThroughRate.index - Index name.
     * @param getClickThroughRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickThroughRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getClickThroughRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getClickThroughRate({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getClickThroughRate`.");
      const n = "/2/clicks/clickThroughRate", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the conversion rate (CR) for all your searches with at least one conversion event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  **There\'s a difference between a 0 and null CR when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, CR is null. - **0** mean there _were_ queries but no [conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getConversionRate - The getConversionRate object.
     * @param getConversionRate.index - Index name.
     * @param getConversionRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getConversionRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getConversionRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getConversionRate({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getConversionRate`.");
      const n = "/2/conversions/conversionRate", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the fraction of searches that didn\'t lead to any click within a time range, including a daily breakdown. It also returns the number of tracked searches and tracked searches without clicks.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getNoClickRate - The getNoClickRate object.
     * @param getNoClickRate.index - Index name.
     * @param getNoClickRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoClickRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoClickRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getNoClickRate({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getNoClickRate`.");
      const n = "/2/searches/noClickRate", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the fraction of searches that didn\'t return any results within a time range, including a daily breakdown. It also returns the count of searches and searches without results used to compute the rates.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getNoResultsRate - The getNoResultsRate object.
     * @param getNoResultsRate.index - Index name.
     * @param getNoResultsRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoResultsRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getNoResultsRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getNoResultsRate({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getNoResultsRate`.");
      const n = "/2/searches/noResultRate", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the purchase rate for all your searches with at least one purchase event, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.  The rate is the number of purchase conversion events divided by the number of tracked searches. A search is tracked if it returns a query ID (`clickAnalytics` is `true`). This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`.  **There\'s a difference between a 0 and null purchase rate when `clickAnalytics` is enabled:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the purchase rate is null. - **0** mean there _were_ queries but no [purchase conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getPurchaseRate - The getPurchaseRate object.
     * @param getPurchaseRate.index - Index name.
     * @param getPurchaseRate.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getPurchaseRate.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getPurchaseRate.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getPurchaseRate({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getPurchaseRate`.");
      const n = "/2/conversions/purchaseRate", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves revenue-related metrics, such as the total revenue or the average order value.  To retrieve revenue-related metrics, send purchase events. By default, the analyzed period includes the last eight days including the current day.  Revenue is based on purchase conversion events (a conversion event with an `eventSubtype` attribute of `purchase`). The revenue is the `price` attribute multiplied by the `quantity` attribute for each object in the event\'s `objectData` array.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getRevenue - The getRevenue object.
     * @param getRevenue.index - Index name.
     * @param getRevenue.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getRevenue.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getRevenue.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRevenue({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getRevenue`.");
      const n = "/2/conversions/revenue", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the number of searches within a time range, including a daily breakdown.  By default, the analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesCount - The getSearchesCount object.
     * @param getSearchesCount.index - Index name.
     * @param getSearchesCount.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesCount.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesCount.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getSearchesCount({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getSearchesCount`.");
      const n = "/2/searches/count", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    },
    /**
     * Retrieves the most popular searches that didn\'t lead to any clicks, from the 1,000 most frequent searches.  For each search, it also returns the number of displayed search results that remained unclicked.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesNoClicks - The getSearchesNoClicks object.
     * @param getSearchesNoClicks.index - Index name.
     * @param getSearchesNoClicks.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoClicks.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoClicks.limit - Number of items to return.
     * @param getSearchesNoClicks.offset - Position of the first item to return.
     * @param getSearchesNoClicks.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getSearchesNoClicks({ index: e, startDate: r, endDate: a, limit: s, offset: o, tags: n }, i) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getSearchesNoClicks`.");
      const d = "/2/searches/noClicks", P = {}, w = {};
      e !== void 0 && (w.index = e.toString()), r !== void 0 && (w.startDate = r.toString()), a !== void 0 && (w.endDate = a.toString()), s !== void 0 && (w.limit = s.toString()), o !== void 0 && (w.offset = o.toString()), n !== void 0 && (w.tags = n.toString());
      const f = {
        method: "GET",
        path: d,
        queryParameters: w,
        headers: P
      };
      return t.request(f, i);
    },
    /**
     * Retrieves the 1,000 most frequent searches that produced zero results.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getSearchesNoResults - The getSearchesNoResults object.
     * @param getSearchesNoResults.index - Index name.
     * @param getSearchesNoResults.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoResults.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getSearchesNoResults.limit - Number of items to return.
     * @param getSearchesNoResults.offset - Position of the first item to return.
     * @param getSearchesNoResults.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getSearchesNoResults({ index: e, startDate: r, endDate: a, limit: s, offset: o, tags: n }, i) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getSearchesNoResults`.");
      const d = "/2/searches/noResults", P = {}, w = {};
      e !== void 0 && (w.index = e.toString()), r !== void 0 && (w.startDate = r.toString()), a !== void 0 && (w.endDate = a.toString()), s !== void 0 && (w.limit = s.toString()), o !== void 0 && (w.offset = o.toString()), n !== void 0 && (w.tags = n.toString());
      const f = {
        method: "GET",
        path: d,
        queryParameters: w,
        headers: P
      };
      return t.request(f, i);
    },
    /**
     * Retrieves the time when the Analytics data for the specified index was last updated.  If the index has been recently created or no search has been performed yet the updated time is `null`.  The Analytics data is updated every 5&nbsp;minutes.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getStatus - The getStatus object.
     * @param getStatus.index - Index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getStatus({ index: e }, r) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getStatus`.");
      const a = "/2/status", s = {}, o = {};
      e !== void 0 && (o.index = e.toString());
      const n = {
        method: "GET",
        path: a,
        queryParameters: o,
        headers: s
      };
      return t.request(n, r);
    },
    /**
     * Retrieves the countries with the most searches in your index.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopCountries - The getTopCountries object.
     * @param getTopCountries.index - Index name.
     * @param getTopCountries.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopCountries.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopCountries.limit - Number of items to return.
     * @param getTopCountries.offset - Position of the first item to return.
     * @param getTopCountries.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTopCountries({ index: e, startDate: r, endDate: a, limit: s, offset: o, tags: n }, i) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getTopCountries`.");
      const d = "/2/countries", P = {}, w = {};
      e !== void 0 && (w.index = e.toString()), r !== void 0 && (w.startDate = r.toString()), a !== void 0 && (w.endDate = a.toString()), s !== void 0 && (w.limit = s.toString()), o !== void 0 && (w.offset = o.toString()), n !== void 0 && (w.tags = n.toString());
      const f = {
        method: "GET",
        path: d,
        queryParameters: w,
        headers: P
      };
      return t.request(f, i);
    },
    /**
     * Retrieves the 1,000 most frequently used filter attributes.  These are attributes of your records that you included in the `attributesForFaceting` setting.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFilterAttributes - The getTopFilterAttributes object.
     * @param getTopFilterAttributes.index - Index name.
     * @param getTopFilterAttributes.search - Search query.
     * @param getTopFilterAttributes.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterAttributes.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterAttributes.limit - Number of items to return.
     * @param getTopFilterAttributes.offset - Position of the first item to return.
     * @param getTopFilterAttributes.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTopFilterAttributes({ index: e, search: r, startDate: a, endDate: s, limit: o, offset: n, tags: i }, d) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getTopFilterAttributes`.");
      const P = "/2/filters", w = {}, f = {};
      e !== void 0 && (f.index = e.toString()), r !== void 0 && (f.search = r.toString()), a !== void 0 && (f.startDate = a.toString()), s !== void 0 && (f.endDate = s.toString()), o !== void 0 && (f.limit = o.toString()), n !== void 0 && (f.offset = n.toString()), i !== void 0 && (f.tags = i.toString());
      const y = {
        method: "GET",
        path: P,
        queryParameters: f,
        headers: w
      };
      return t.request(y, d);
    },
    /**
     * Retrieves the 1,000 most frequent filter (facet) values for a filter attribute.  These are attributes of your records that you included in the `attributesForFaceting` setting.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFilterForAttribute - The getTopFilterForAttribute object.
     * @param getTopFilterForAttribute.attribute - Attribute name.
     * @param getTopFilterForAttribute.index - Index name.
     * @param getTopFilterForAttribute.search - Search query.
     * @param getTopFilterForAttribute.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterForAttribute.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFilterForAttribute.limit - Number of items to return.
     * @param getTopFilterForAttribute.offset - Position of the first item to return.
     * @param getTopFilterForAttribute.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTopFilterForAttribute({ attribute: e, index: r, search: a, startDate: s, endDate: o, limit: n, offset: i, tags: d }, P) {
      if (!e)
        throw new Error("Parameter `attribute` is required when calling `getTopFilterForAttribute`.");
      if (!r)
        throw new Error("Parameter `index` is required when calling `getTopFilterForAttribute`.");
      const w = "/2/filters/{attribute}".replace("{attribute}", encodeURIComponent(e)), f = {}, y = {};
      r !== void 0 && (y.index = r.toString()), a !== void 0 && (y.search = a.toString()), s !== void 0 && (y.startDate = s.toString()), o !== void 0 && (y.endDate = o.toString()), n !== void 0 && (y.limit = n.toString()), i !== void 0 && (y.offset = i.toString()), d !== void 0 && (y.tags = d.toString());
      const p = {
        method: "GET",
        path: w,
        queryParameters: y,
        headers: f
      };
      return t.request(p, P);
    },
    /**
     * Retrieves the 1,000 most frequently used filters for a search that didn\'t return any results.  To get the most frequent searches without results, use the [Retrieve searches without results](https://www.algolia.com/doc/rest-api/analytics/get-searches-no-results) operation.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopFiltersNoResults - The getTopFiltersNoResults object.
     * @param getTopFiltersNoResults.index - Index name.
     * @param getTopFiltersNoResults.search - Search query.
     * @param getTopFiltersNoResults.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFiltersNoResults.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopFiltersNoResults.limit - Number of items to return.
     * @param getTopFiltersNoResults.offset - Position of the first item to return.
     * @param getTopFiltersNoResults.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTopFiltersNoResults({ index: e, search: r, startDate: a, endDate: s, limit: o, offset: n, tags: i }, d) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getTopFiltersNoResults`.");
      const P = "/2/filters/noResults", w = {}, f = {};
      e !== void 0 && (f.index = e.toString()), r !== void 0 && (f.search = r.toString()), a !== void 0 && (f.startDate = a.toString()), s !== void 0 && (f.endDate = s.toString()), o !== void 0 && (f.limit = o.toString()), n !== void 0 && (f.offset = n.toString()), i !== void 0 && (f.tags = i.toString());
      const y = {
        method: "GET",
        path: P,
        queryParameters: f,
        headers: w
      };
      return t.request(y, d);
    },
    /**
     * Retrieves the object IDs of the 1,000 most frequent search results.  If you set the `clickAnalytics` query parameter to true, the response also includes:  - Tracked searches count. Tracked searches are Search API requests with the `clickAnalytics` parameter set to `true`. This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`. - Click count - Click-through rate (CTR) - Conversion count - Conversion rate (CR) - Average click position  If you set the `revenueAnalytics` parameter to `true`, the response also includes:  - Add-to-cart count - Add-to-cart rate (ATCR) - Purchase count - Purchase rate - Revenue details for each currency  **There\'s a difference between 0% rates and null rates:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the rates (CTR, CR, ATCR, purchase rate) are null. - **0% rates** mean there _were_ queries but no [click or conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopHits - The getTopHits object.
     * @param getTopHits.index - Index name.
     * @param getTopHits.search - Search query.
     * @param getTopHits.clickAnalytics - Whether to include metrics related to click and conversion events in the response.
     * @param getTopHits.revenueAnalytics - Whether to include metrics related to revenue events in the response.
     * @param getTopHits.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopHits.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopHits.limit - Number of items to return.
     * @param getTopHits.offset - Position of the first item to return.
     * @param getTopHits.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTopHits({ index: e, search: r, clickAnalytics: a, revenueAnalytics: s, startDate: o, endDate: n, limit: i, offset: d, tags: P }, w) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getTopHits`.");
      const f = "/2/hits", y = {}, p = {};
      e !== void 0 && (p.index = e.toString()), r !== void 0 && (p.search = r.toString()), a !== void 0 && (p.clickAnalytics = a.toString()), s !== void 0 && (p.revenueAnalytics = s.toString()), o !== void 0 && (p.startDate = o.toString()), n !== void 0 && (p.endDate = n.toString()), i !== void 0 && (p.limit = i.toString()), d !== void 0 && (p.offset = d.toString()), P !== void 0 && (p.tags = P.toString());
      const v = {
        method: "GET",
        path: f,
        queryParameters: p,
        headers: y
      };
      return t.request(v, w);
    },
    /**
     * Returns the most popular searches. For each search, it also includes the average number of hits.  If you set the `clickAnalytics` query parameter to `true`, the response also includes  - Tracked searches count. Tracked searches are Search API requests with the `clickAnalytics` parameter set to `true`. This differs from the response\'s `count`, which shows the overall number of searches, including those where `clickAnalytics` is `false`. - Click count - Click-through rate (CTR) - Conversion count - Conversion rate (CR) - Average click position  If you set the `revenueAnalytics` query parameter to `true`, the response also includes:  - Add-to-cart count - Add-to-cart rate (ATCR) - Purchase count - Purchase rate - Revenue details for each currency  **There\'s a difference between 0% rates and null rates:**  - **Null** means there were no queries: since Algolia didn\'t receive any events, the rates (CTR, CR, ATCR, purchase rate) are null. - **0% rates** mean there _were_ queries but no [click or conversion events](https://www.algolia.com/doc/guides/sending-events/getting-started) were received.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getTopSearches - The getTopSearches object.
     * @param getTopSearches.index - Index name.
     * @param getTopSearches.clickAnalytics - Whether to include metrics related to click and conversion events in the response.
     * @param getTopSearches.revenueAnalytics - Whether to include metrics related to revenue events in the response.
     * @param getTopSearches.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopSearches.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getTopSearches.orderBy - Attribute by which to order the response items.  If the `clickAnalytics` parameter is false, only `searchCount` is available.
     * @param getTopSearches.direction - Sorting direction of the results: ascending or descending.
     * @param getTopSearches.limit - Number of items to return.
     * @param getTopSearches.offset - Position of the first item to return.
     * @param getTopSearches.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTopSearches({
      index: e,
      clickAnalytics: r,
      revenueAnalytics: a,
      startDate: s,
      endDate: o,
      orderBy: n,
      direction: i,
      limit: d,
      offset: P,
      tags: w
    }, f) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getTopSearches`.");
      const y = "/2/searches", p = {}, v = {};
      e !== void 0 && (v.index = e.toString()), r !== void 0 && (v.clickAnalytics = r.toString()), a !== void 0 && (v.revenueAnalytics = a.toString()), s !== void 0 && (v.startDate = s.toString()), o !== void 0 && (v.endDate = o.toString()), n !== void 0 && (v.orderBy = n.toString()), i !== void 0 && (v.direction = i.toString()), d !== void 0 && (v.limit = d.toString()), P !== void 0 && (v.offset = P.toString()), w !== void 0 && (v.tags = w.toString());
      const S = {
        method: "GET",
        path: y,
        queryParameters: v,
        headers: p
      };
      return t.request(S, f);
    },
    /**
     * Retrieves the number of unique users within a time range, including a daily breakdown.  Since it returns the number of unique users, the sum of the daily values might be different from the total number.  By default:  - Algolia distinguishes search users by their IP address, _unless_ you include a pseudonymous user identifier in your search requests with the `userToken` API parameter or `x-algolia-usertoken` request header. - The analyzed period includes the last eight days including the current day.
     *
     * Required API Key ACLs:
     *  - analytics
     * @param getUsersCount - The getUsersCount object.
     * @param getUsersCount.index - Index name.
     * @param getUsersCount.startDate - Start date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getUsersCount.endDate - End date of the period to analyze, in `YYYY-MM-DD` format.
     * @param getUsersCount.tags - Tags by which to segment the analytics.  You can combine multiple tags with `OR` and `AND`. Tags must be URL-encoded. For more information, see [Segment your analytics data](https://www.algolia.com/doc/guides/search-analytics/guides/segments).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getUsersCount({ index: e, startDate: r, endDate: a, tags: s }, o) {
      if (!e)
        throw new Error("Parameter `index` is required when calling `getUsersCount`.");
      const n = "/2/users/count", i = {}, d = {};
      e !== void 0 && (d.index = e.toString()), r !== void 0 && (d.startDate = r.toString()), a !== void 0 && (d.endDate = a.toString()), s !== void 0 && (d.tags = s.toString());
      const P = {
        method: "GET",
        path: n,
        queryParameters: d,
        headers: i
      };
      return t.request(P, o);
    }
  };
}
function Ee(c, u, h, m) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  if (h && (typeof h != "string" || !he.includes(h)))
    throw new Error(`\`region\` must be one of the following: ${he.join(", ")}`);
  return ir({
    appId: c,
    apiKey: u,
    region: h,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${J}-${c}` }), E()]
    }),
    ...m
  });
}
const ur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  analyticsClient: Ee,
  apiClientVersion: J
}, Symbol.toStringTag, { value: "Module" }));
var K = "5.44.0", de = ["de", "us"];
function cr(c) {
  return [{ url: c ? "insights.{region}.algolia.io".replace("{region}", c) : "insights.algolia.io", accept: "readWrite", protocol: "https" }];
}
function hr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  region: g,
  ...q
}) {
  const l = k(c, u, h), t = U({
    hosts: cr(g),
    ...q,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Insights",
      version: K
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...l.headers(),
      ...q.baseHeaders
    },
    baseQueryParameters: {
      ...l.queryParameters(),
      ...q.baseQueryParameters
    }
  });
  return {
    transporter: t,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([t.requestsCache.clear(), t.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return t.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, r) {
      t.algoliaAgent.add({ segment: e, version: r });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !h || h === "WithinHeaders" ? t.baseHeaders["x-algolia-api-key"] = e : t.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const i = {
        method: "DELETE",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const i = {
        method: "GET",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const d = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const d = {
        method: "PUT",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * Deletes all events related to the specified user token from events metrics and analytics. The deletion is asynchronous, and processed within 48 hours. To delete a personalization user profile, see `Delete a user profile` in the Personalization API.
     *
     * Required API Key ACLs:
     *  - deleteObject
     * @param deleteUserToken - The deleteUserToken object.
     * @param deleteUserToken.userToken - User token for which to delete all associated events.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteUserToken({ userToken: e }, r) {
      if (!e)
        throw new Error("Parameter `userToken` is required when calling `deleteUserToken`.");
      const n = {
        method: "DELETE",
        path: "/1/usertokens/{userToken}".replace("{userToken}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Sends a list of events to the Insights API.  You can include up to 1,000 events in a single request, but the request body must be smaller than 2&nbsp;MB.
     *
     * Required API Key ACLs:
     *  - search
     * @param insightsEvents - The insightsEvents object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    pushEvents(e, r) {
      if (!e)
        throw new Error("Parameter `insightsEvents` is required when calling `pushEvents`.");
      if (!e.events)
        throw new Error("Parameter `insightsEvents.events` is required when calling `pushEvents`.");
      const n = {
        method: "POST",
        path: "/1/events",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    }
  };
}
function ve(c, u, h, m) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  if (h && (typeof h != "string" || !de.includes(h)))
    throw new Error(`\`region\` must be one of the following: ${de.join(", ")}`);
  return hr({
    appId: c,
    apiKey: u,
    region: h,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${K}-${c}` }), E()]
    }),
    ...m
  });
}
const dr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apiClientVersion: K,
  insightsClient: ve
}, Symbol.toStringTag, { value: "Module" }));
var X = "5.44.0", le = ["eu", "us"];
function lr(c) {
  return [{ url: "personalization.{region}.algolia.com".replace("{region}", c), accept: "readWrite", protocol: "https" }];
}
function mr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  region: g,
  ...q
}) {
  const l = k(c, u, h), t = U({
    hosts: lr(g),
    ...q,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Personalization",
      version: X
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...l.headers(),
      ...q.baseHeaders
    },
    baseQueryParameters: {
      ...l.queryParameters(),
      ...q.baseQueryParameters
    }
  });
  return {
    transporter: t,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([t.requestsCache.clear(), t.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return t.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, r) {
      t.algoliaAgent.add({ segment: e, version: r });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !h || h === "WithinHeaders" ? t.baseHeaders["x-algolia-api-key"] = e : t.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const i = {
        method: "DELETE",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const i = {
        method: "GET",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const d = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const d = {
        method: "PUT",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * Deletes a user profile.  The response includes a date and time when the user profile can safely be considered deleted.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param deleteUserProfile - The deleteUserProfile object.
     * @param deleteUserProfile.userToken - Unique identifier representing a user for which to fetch the personalization profile.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteUserProfile({ userToken: e }, r) {
      if (!e)
        throw new Error("Parameter `userToken` is required when calling `deleteUserProfile`.");
      const n = {
        method: "DELETE",
        path: "/1/profiles/{userToken}".replace("{userToken}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves the current personalization strategy.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getPersonalizationStrategy(e) {
      const o = {
        method: "GET",
        path: "/1/strategies/personalization",
        queryParameters: {},
        headers: {}
      };
      return t.request(o, e);
    },
    /**
     * Retrieves a user profile and their affinities for different facets.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param getUserTokenProfile - The getUserTokenProfile object.
     * @param getUserTokenProfile.userToken - Unique identifier representing a user for which to fetch the personalization profile.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getUserTokenProfile({ userToken: e }, r) {
      if (!e)
        throw new Error("Parameter `userToken` is required when calling `getUserTokenProfile`.");
      const n = {
        method: "GET",
        path: "/1/profiles/personalization/{userToken}".replace(
          "{userToken}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Creates a new personalization strategy.
     *
     * Required API Key ACLs:
     *  - recommendation
     * @param personalizationStrategyParams - The personalizationStrategyParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    setPersonalizationStrategy(e, r) {
      if (!e)
        throw new Error(
          "Parameter `personalizationStrategyParams` is required when calling `setPersonalizationStrategy`."
        );
      if (!e.eventsScoring)
        throw new Error(
          "Parameter `personalizationStrategyParams.eventsScoring` is required when calling `setPersonalizationStrategy`."
        );
      if (!e.facetsScoring)
        throw new Error(
          "Parameter `personalizationStrategyParams.facetsScoring` is required when calling `setPersonalizationStrategy`."
        );
      if (!e.personalizationImpact)
        throw new Error(
          "Parameter `personalizationStrategyParams.personalizationImpact` is required when calling `setPersonalizationStrategy`."
        );
      const n = {
        method: "POST",
        path: "/1/strategies/personalization",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    }
  };
}
function Se(c, u, h, m) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  if (!h || h && (typeof h != "string" || !le.includes(h)))
    throw new Error(`\`region\` is required and must be one of the following: ${le.join(", ")}`);
  return mr({
    appId: c,
    apiKey: u,
    region: h,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${X}-${c}` }), E()]
    }),
    ...m
  });
}
const qr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apiClientVersion: X,
  personalizationClient: Se
}, Symbol.toStringTag, { value: "Module" }));
var Y = "5.44.0", me = ["eu", "us"];
function Pr(c) {
  return [{ url: "query-suggestions.{region}.algolia.com".replace("{region}", c), accept: "readWrite", protocol: "https" }];
}
function gr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  region: g,
  ...q
}) {
  const l = k(c, u, h), t = U({
    hosts: Pr(g),
    ...q,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "QuerySuggestions",
      version: Y
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...l.headers(),
      ...q.baseHeaders
    },
    baseQueryParameters: {
      ...l.queryParameters(),
      ...q.baseQueryParameters
    }
  });
  return {
    transporter: t,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([t.requestsCache.clear(), t.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return t.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, r) {
      t.algoliaAgent.add({ segment: e, version: r });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !h || h === "WithinHeaders" ? t.baseHeaders["x-algolia-api-key"] = e : t.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * Creates a new Query Suggestions configuration.  You can have up to 100 configurations per Algolia application.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param configurationWithIndex - The configurationWithIndex object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    createConfig(e, r) {
      if (!e)
        throw new Error("Parameter `configurationWithIndex` is required when calling `createConfig`.");
      const n = {
        method: "POST",
        path: "/1/configs",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const i = {
        method: "DELETE",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const i = {
        method: "GET",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const d = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const d = {
        method: "PUT",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * Deletes a Query Suggestions configuration.  Deleting only removes the configuration and stops updates to the Query Suggestions index. To delete the Query Suggestions index itself, use the Search API and the `Delete an index` operation.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteConfig - The deleteConfig object.
     * @param deleteConfig.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteConfig({ indexName: e }, r) {
      if (!e)
        throw new Error("Parameter `indexName` is required when calling `deleteConfig`.");
      const n = {
        method: "DELETE",
        path: "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves all Query Suggestions configurations of your Algolia application.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getAllConfigs(e) {
      const o = {
        method: "GET",
        path: "/1/configs",
        queryParameters: {},
        headers: {}
      };
      return t.request(o, e);
    },
    /**
     * Retrieves a single Query Suggestions configuration by its index name.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getConfig - The getConfig object.
     * @param getConfig.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getConfig({ indexName: e }, r) {
      if (!e)
        throw new Error("Parameter `indexName` is required when calling `getConfig`.");
      const n = {
        method: "GET",
        path: "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Reports the status of a Query Suggestions index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getConfigStatus - The getConfigStatus object.
     * @param getConfigStatus.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getConfigStatus({ indexName: e }, r) {
      if (!e)
        throw new Error("Parameter `indexName` is required when calling `getConfigStatus`.");
      const n = {
        method: "GET",
        path: "/1/configs/{indexName}/status".replace("{indexName}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves the logs for a single Query Suggestions index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getLogFile - The getLogFile object.
     * @param getLogFile.indexName - Query Suggestions index name.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getLogFile({ indexName: e }, r) {
      if (!e)
        throw new Error("Parameter `indexName` is required when calling `getLogFile`.");
      const n = {
        method: "GET",
        path: "/1/logs/{indexName}".replace("{indexName}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Updates a QuerySuggestions configuration.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param updateConfig - The updateConfig object.
     * @param updateConfig.indexName - Query Suggestions index name.
     * @param updateConfig.configuration - The configuration object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateConfig({ indexName: e, configuration: r }, a) {
      if (!e)
        throw new Error("Parameter `indexName` is required when calling `updateConfig`.");
      if (!r)
        throw new Error("Parameter `configuration` is required when calling `updateConfig`.");
      if (!r.sourceIndices)
        throw new Error("Parameter `configuration.sourceIndices` is required when calling `updateConfig`.");
      const i = {
        method: "PUT",
        path: "/1/configs/{indexName}".replace("{indexName}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    }
  };
}
function Te(c, u, h, m) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  if (!h || h && (typeof h != "string" || !me.includes(h)))
    throw new Error(`\`region\` is required and must be one of the following: ${me.join(", ")}`);
  return gr({
    appId: c,
    apiKey: u,
    region: h,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${Y}-${c}` }), E()]
    }),
    ...m
  });
}
const wr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apiClientVersion: Y,
  querySuggestionsClient: Te
}, Symbol.toStringTag, { value: "Module" }));
var B = "5.44.0";
function fr(c) {
  return [
    {
      url: `${c}-dsn.algolia.net`,
      accept: "read",
      protocol: "https"
    },
    {
      url: `${c}.algolia.net`,
      accept: "write",
      protocol: "https"
    }
  ].concat(
    we([
      {
        url: `${c}-1.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${c}-2.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${c}-3.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      }
    ])
  );
}
function pr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  ...g
}) {
  const q = k(c, u, h), l = U({
    hosts: fr(c),
    ...g,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Search",
      version: B
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...q.headers(),
      ...g.baseHeaders
    },
    baseQueryParameters: {
      ...q.queryParameters(),
      ...g.baseQueryParameters
    }
  });
  return {
    transporter: l,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([l.requestsCache.clear(), l.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return l.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(t, e) {
      l.algoliaAgent.add({ segment: t, version: e });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: t }) {
      !h || h === "WithinHeaders" ? l.baseHeaders["x-algolia-api-key"] = t : l.baseQueryParameters["x-algolia-api-key"] = t;
    },
    /**
     * Helper: Wait for a task to be published (completed) for a given `indexName` and `taskID`.
     *
     * @summary Helper method that waits for a task to be published (completed).
     * @param waitForTaskOptions - The `waitForTaskOptions` object.
     * @param waitForTaskOptions.indexName - The `indexName` where the operation was performed.
     * @param waitForTaskOptions.taskID - The `taskID` returned in the method response.
     * @param waitForTaskOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForTaskOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */
    waitForTask({
      indexName: t,
      taskID: e,
      maxRetries: r = 50,
      timeout: a = (o) => Math.min(o * 200, 5e3)
    }, s) {
      let o = 0;
      return G({
        func: () => this.getTask({ indexName: t, taskID: e }, s),
        validate: (n) => n.status === "published",
        aggregator: () => o += 1,
        error: {
          validate: () => o >= r,
          message: () => `The maximum number of retries exceeded. (${o}/${r})`
        },
        timeout: () => a(o)
      });
    },
    /**
     * Helper: Wait for an application-level task to complete for a given `taskID`.
     *
     * @summary Helper method that waits for a task to be published (completed).
     * @param waitForAppTaskOptions - The `waitForTaskOptions` object.
     * @param waitForAppTaskOptions.taskID - The `taskID` returned in the method response.
     * @param waitForAppTaskOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForAppTaskOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */
    waitForAppTask({
      taskID: t,
      maxRetries: e = 50,
      timeout: r = (s) => Math.min(s * 200, 5e3)
    }, a) {
      let s = 0;
      return G({
        func: () => this.getAppTask({ taskID: t }, a),
        validate: (o) => o.status === "published",
        aggregator: () => s += 1,
        error: {
          validate: () => s >= e,
          message: () => `The maximum number of retries exceeded. (${s}/${e})`
        },
        timeout: () => r(s)
      });
    },
    /**
     * Helper: Wait for an API key to be added, updated or deleted based on a given `operation`.
     *
     * @summary Helper method that waits for an API key task to be processed.
     * @param waitForApiKeyOptions - The `waitForApiKeyOptions` object.
     * @param waitForApiKeyOptions.operation - The `operation` that was done on a `key`.
     * @param waitForApiKeyOptions.key - The `key` that has been added, deleted or updated.
     * @param waitForApiKeyOptions.apiKey - Necessary to know if an `update` operation has been processed, compare fields of the response with it.
     * @param waitForApiKeyOptions.maxRetries - The maximum number of retries. 50 by default.
     * @param waitForApiKeyOptions.timeout - The function to decide how long to wait between retries.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getApikey` method and merged with the transporter requestOptions.
     */
    waitForApiKey({
      operation: t,
      key: e,
      apiKey: r,
      maxRetries: a = 50,
      timeout: s = (n) => Math.min(n * 200, 5e3)
    }, o) {
      let n = 0;
      const i = {
        aggregator: () => n += 1,
        error: {
          validate: () => n >= a,
          message: () => `The maximum number of retries exceeded. (${n}/${a})`
        },
        timeout: () => s(n)
      };
      if (t === "update") {
        if (!r)
          throw new Error("`apiKey` is required when waiting for an `update` operation.");
        return G({
          ...i,
          func: () => this.getApiKey({ key: e }, o),
          validate: (d) => {
            for (const P of Object.keys(r)) {
              const w = r[P], f = d[P];
              if (Array.isArray(w) && Array.isArray(f)) {
                if (w.length !== f.length || w.some((y, p) => y !== f[p]))
                  return !1;
              } else if (w !== f)
                return !1;
            }
            return !0;
          }
        });
      }
      return G({
        ...i,
        func: () => this.getApiKey({ key: e }, o).catch((d) => {
          if (d.status !== 404)
            throw d;
        }),
        validate: (d) => t === "add" ? d !== void 0 : d === void 0
      });
    },
    /**
     * Helper: Iterate on the `browse` method of the client to allow aggregating objects of an index.
     *
     * @summary Helper method that iterates on the `browse` method.
     * @param browseObjects - The `browseObjects` object.
     * @param browseObjects.indexName - The index in which to perform the request.
     * @param browseObjects.browseParams - The `browse` parameters.
     * @param browseObjects.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is no `cursor` in the response.
     * @param browseObjects.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `browse` method and merged with the transporter requestOptions.
     */
    browseObjects({ indexName: t, browseParams: e, ...r }, a) {
      return G({
        func: (s) => this.browse(
          {
            indexName: t,
            browseParams: {
              cursor: s ? s.cursor : void 0,
              hitsPerPage: 1e3,
              ...e
            }
          },
          a
        ),
        validate: (s) => s.cursor === void 0,
        ...r
      });
    },
    /**
     * Helper: Iterate on the `searchRules` method of the client to allow aggregating rules of an index.
     *
     * @summary Helper method that iterates on the `searchRules` method.
     * @param browseRules - The `browseRules` object.
     * @param browseRules.indexName - The index in which to perform the request.
     * @param browseRules.searchRulesParams - The `searchRules` method parameters.
     * @param browseRules.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is less hits returned than the number of maximum hits (1000).
     * @param browseRules.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `searchRules` method and merged with the transporter requestOptions.
     */
    browseRules({ indexName: t, searchRulesParams: e, ...r }, a) {
      const s = {
        ...e,
        hitsPerPage: (e == null ? void 0 : e.hitsPerPage) || 1e3
      };
      return G({
        func: (o) => this.searchRules(
          {
            indexName: t,
            searchRulesParams: {
              ...s,
              page: o ? o.page + 1 : s.page || 0
            }
          },
          a
        ),
        validate: (o) => o.hits.length < s.hitsPerPage,
        ...r
      });
    },
    /**
     * Helper: Iterate on the `searchSynonyms` method of the client to allow aggregating rules of an index.
     *
     * @summary Helper method that iterates on the `searchSynonyms` method.
     * @param browseSynonyms - The `browseSynonyms` object.
     * @param browseSynonyms.indexName - The index in which to perform the request.
     * @param browseSynonyms.validate - The validator function. It receive the resolved return of the API call. By default, stops when there is less hits returned than the number of maximum hits (1000).
     * @param browseSynonyms.aggregator - The function that runs right after the API call has been resolved, allows you to do anything with the response before `validate`.
     * @param browseSynonyms.searchSynonymsParams - The `searchSynonyms` method parameters.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `searchSynonyms` method and merged with the transporter requestOptions.
     */
    browseSynonyms({
      indexName: t,
      searchSynonymsParams: e,
      ...r
    }, a) {
      const s = {
        ...e,
        page: (e == null ? void 0 : e.page) || 0,
        hitsPerPage: 1e3
      };
      return G({
        func: (o) => {
          const n = this.searchSynonyms(
            {
              indexName: t,
              searchSynonymsParams: {
                ...s,
                page: s.page
              }
            },
            a
          );
          return s.page += 1, n;
        },
        validate: (o) => o.hits.length < s.hitsPerPage,
        ...r
      });
    },
    /**
     * Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     *
     * @summary Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     * @param chunkedBatch - The `chunkedBatch` object.
     * @param chunkedBatch.indexName - The `indexName` to replace `objects` in.
     * @param chunkedBatch.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param chunkedBatch.action - The `batch` `action` to perform on the given array of `objects`, defaults to `addObject`.
     * @param chunkedBatch.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param chunkedBatch.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */
    async chunkedBatch({ indexName: t, objects: e, action: r = "addObject", waitForTasks: a, batchSize: s = 1e3 }, o) {
      let n = [];
      const i = [], d = e.entries();
      for (const [P, w] of d)
        n.push({ action: r, body: w }), (n.length === s || P === e.length - 1) && (i.push(await this.batch({ indexName: t, batchWriteParams: { requests: n } }, o)), n = []);
      if (a)
        for (const P of i)
          await this.waitForTask({ indexName: t, taskID: P.taskID });
      return i;
    },
    /**
     * Helper: Saves the given array of objects in the given index. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     *
     * @summary Helper: Saves the given array of objects in the given index. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     * @param saveObjects - The `saveObjects` object.
     * @param saveObjects.indexName - The `indexName` to save `objects` in.
     * @param saveObjects.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param saveObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param saveObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch` method and merged with the transporter requestOptions.
     */
    async saveObjects({ indexName: t, objects: e, waitForTasks: r, batchSize: a }, s) {
      return await this.chunkedBatch(
        { indexName: t, objects: e, action: "addObject", waitForTasks: r, batchSize: a },
        s
      );
    },
    /**
     * Helper: Deletes every records for the given objectIDs. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objectIDs in it.
     *
     * @summary Helper: Deletes every records for the given objectIDs. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objectIDs in it.
     * @param deleteObjects - The `deleteObjects` object.
     * @param deleteObjects.indexName - The `indexName` to delete `objectIDs` from.
     * @param deleteObjects.objectIDs - The objectIDs to delete.
     * @param deleteObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param deleteObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch` method and merged with the transporter requestOptions.
     */
    async deleteObjects({ indexName: t, objectIDs: e, waitForTasks: r, batchSize: a }, s) {
      return await this.chunkedBatch(
        {
          indexName: t,
          objects: e.map((o) => ({ objectID: o })),
          action: "deleteObject",
          waitForTasks: r,
          batchSize: a
        },
        s
      );
    },
    /**
     * Helper: Replaces object content of all the given objects according to their respective `objectID` field. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     *
     * @summary Helper: Replaces object content of all the given objects according to their respective `objectID` field. The `chunkedBatch` helper is used under the hood, which creates a `batch` requests with at most 1000 objects in it.
     * @param partialUpdateObjects - The `partialUpdateObjects` object.
     * @param partialUpdateObjects.indexName - The `indexName` to update `objects` in.
     * @param partialUpdateObjects.objects - The array of `objects` to update in the given Algolia `indexName`.
     * @param partialUpdateObjects.createIfNotExists - To be provided if non-existing objects are passed, otherwise, the call will fail.
     * @param partialUpdateObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param partialUpdateObjects.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getTask` method and merged with the transporter requestOptions.
     */
    async partialUpdateObjects({ indexName: t, objects: e, createIfNotExists: r, waitForTasks: a, batchSize: s }, o) {
      return await this.chunkedBatch(
        {
          indexName: t,
          objects: e,
          action: r ? "partialUpdateObject" : "partialUpdateObjectNoCreate",
          batchSize: s,
          waitForTasks: a
        },
        o
      );
    },
    /**
     * Helper: Replaces all objects (records) in the given `index_name` with the given `objects`. A temporary index is created during this process in order to backup your data.
     * See https://api-clients-automation.netlify.app/docs/custom-helpers/#replaceallobjects for implementation details.
     *
     * @summary Helper: Replaces all objects (records) in the given `index_name` with the given `objects`. A temporary index is created during this process in order to backup your data.
     * @param replaceAllObjects - The `replaceAllObjects` object.
     * @param replaceAllObjects.indexName - The `indexName` to replace `objects` in.
     * @param replaceAllObjects.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param replaceAllObjects.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `objects.length / batchSize`. Defaults to 1000.
     * @param replaceAllObjects.scopes - The `scopes` to keep from the index. Defaults to ['settings', 'rules', 'synonyms'].
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `batch`, `operationIndex` and `getTask` method and merged with the transporter requestOptions.
     */
    async replaceAllObjects({ indexName: t, objects: e, batchSize: r, scopes: a }, s) {
      const o = Math.floor(Math.random() * 1e6) + 1e5, n = `${t}_tmp_${o}`;
      a === void 0 && (a = ["settings", "rules", "synonyms"]);
      try {
        let i = await this.operationIndex(
          {
            indexName: t,
            operationIndexParams: {
              operation: "copy",
              destination: n,
              scope: a
            }
          },
          s
        );
        const d = await this.chunkedBatch(
          { indexName: n, objects: e, waitForTasks: !0, batchSize: r },
          s
        );
        await this.waitForTask({
          indexName: n,
          taskID: i.taskID
        }), i = await this.operationIndex(
          {
            indexName: t,
            operationIndexParams: {
              operation: "copy",
              destination: n,
              scope: a
            }
          },
          s
        ), await this.waitForTask({
          indexName: n,
          taskID: i.taskID
        });
        const P = await this.operationIndex(
          {
            indexName: n,
            operationIndexParams: { operation: "move", destination: t }
          },
          s
        );
        return await this.waitForTask({
          indexName: n,
          taskID: P.taskID
        }), { copyOperationResponse: i, batchResponses: d, moveOperationResponse: P };
      } catch (i) {
        throw await this.deleteIndex({ indexName: n }), i;
      }
    },
    async indexExists({ indexName: t }) {
      try {
        await this.getSettings({ indexName: t });
      } catch (e) {
        if (e instanceof H && e.status === 404)
          return !1;
        throw e;
      }
      return !0;
    },
    /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia records (hits) and not facets.
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `hits` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `hits`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchForHits(t, e) {
      return this.search(t, e);
    },
    /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia facets and not records (hits).
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `facets` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `facets`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchForFacets(t, e) {
      return this.search(t, e);
    },
    /**
     * Creates a new API key with specific permissions and restrictions.
     *
     * Required API Key ACLs:
     *  - admin
     * @param apiKey - The apiKey object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    addApiKey(t, e) {
      if (!t)
        throw new Error("Parameter `apiKey` is required when calling `addApiKey`.");
      if (!t.acl)
        throw new Error("Parameter `apiKey.acl` is required when calling `addApiKey`.");
      const o = {
        method: "POST",
        path: "/1/keys",
        queryParameters: {},
        headers: {},
        data: t
      };
      return l.request(o, e);
    },
    /**
     * If a record with the specified object ID exists, the existing record is replaced. Otherwise, a new record is added to the index.  If you want to use auto-generated object IDs, use the [`saveObject` operation](https://www.algolia.com/doc/rest-api/search/save-object). To update _some_ attributes of an existing record, use the [`partial` operation](https://www.algolia.com/doc/rest-api/search/partial-update-object) instead. To add, update, or replace multiple records, use the [`batch` operation](https://www.algolia.com/doc/rest-api/search/batch).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param addOrUpdateObject - The addOrUpdateObject object.
     * @param addOrUpdateObject.indexName - Name of the index on which to perform the operation.
     * @param addOrUpdateObject.objectID - Unique record identifier.
     * @param addOrUpdateObject.body - The record. A schemaless object with attributes that are useful in the context of search and discovery.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    addOrUpdateObject({ indexName: t, objectID: e, body: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `addOrUpdateObject`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `addOrUpdateObject`.");
      if (!r)
        throw new Error("Parameter `body` is required when calling `addOrUpdateObject`.");
      const i = {
        method: "PUT",
        path: "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r
      };
      return l.request(i, a);
    },
    /**
     * Adds a source to the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param source - Source to add.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    appendSource(t, e) {
      if (!t)
        throw new Error("Parameter `source` is required when calling `appendSource`.");
      if (!t.source)
        throw new Error("Parameter `source.source` is required when calling `appendSource`.");
      const o = {
        method: "POST",
        path: "/1/security/sources/append",
        queryParameters: {},
        headers: {},
        data: t
      };
      return l.request(o, e);
    },
    /**
     * Assigns or moves a user ID to a cluster.  The time it takes to move a user is proportional to the amount of data linked to the user ID.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param assignUserId - The assignUserId object.
     * @param assignUserId.xAlgoliaUserID - Unique identifier of the user who makes the search request.
     * @param assignUserId.assignUserIdParams - The assignUserIdParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    assignUserId({ xAlgoliaUserID: t, assignUserIdParams: e }, r) {
      if (!t)
        throw new Error("Parameter `xAlgoliaUserID` is required when calling `assignUserId`.");
      if (!e)
        throw new Error("Parameter `assignUserIdParams` is required when calling `assignUserId`.");
      if (!e.cluster)
        throw new Error("Parameter `assignUserIdParams.cluster` is required when calling `assignUserId`.");
      const a = "/1/clusters/mapping", s = {}, o = {};
      t !== void 0 && (s["X-Algolia-User-ID"] = t.toString());
      const n = {
        method: "POST",
        path: a,
        queryParameters: o,
        headers: s,
        data: e
      };
      return l.request(n, r);
    },
    /**
     * Adds, updates, or deletes records in one index with a single API request.  Batching index updates reduces latency and increases data integrity.  - Actions are applied in the order they\'re specified. - Actions are equivalent to the individual API requests of the same name.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param batch - The batch object.
     * @param batch.indexName - Name of the index on which to perform the operation.
     * @param batch.batchWriteParams - The batchWriteParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    batch({ indexName: t, batchWriteParams: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `batch`.");
      if (!e)
        throw new Error("Parameter `batchWriteParams` is required when calling `batch`.");
      if (!e.requests)
        throw new Error("Parameter `batchWriteParams.requests` is required when calling `batch`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}/batch".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e
      };
      return l.request(n, r);
    },
    /**
     * Assigns multiple user IDs to a cluster.  **You can\'t move users with this operation**.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param batchAssignUserIds - The batchAssignUserIds object.
     * @param batchAssignUserIds.xAlgoliaUserID - Unique identifier of the user who makes the search request.
     * @param batchAssignUserIds.batchAssignUserIdsParams - The batchAssignUserIdsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    batchAssignUserIds({ xAlgoliaUserID: t, batchAssignUserIdsParams: e }, r) {
      if (!t)
        throw new Error("Parameter `xAlgoliaUserID` is required when calling `batchAssignUserIds`.");
      if (!e)
        throw new Error("Parameter `batchAssignUserIdsParams` is required when calling `batchAssignUserIds`.");
      if (!e.cluster)
        throw new Error("Parameter `batchAssignUserIdsParams.cluster` is required when calling `batchAssignUserIds`.");
      if (!e.users)
        throw new Error("Parameter `batchAssignUserIdsParams.users` is required when calling `batchAssignUserIds`.");
      const a = "/1/clusters/mapping/batch", s = {}, o = {};
      t !== void 0 && (s["X-Algolia-User-ID"] = t.toString());
      const n = {
        method: "POST",
        path: a,
        queryParameters: o,
        headers: s,
        data: e
      };
      return l.request(n, r);
    },
    /**
     * Adds or deletes multiple entries from your plurals, segmentation, or stop word dictionaries.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param batchDictionaryEntries - The batchDictionaryEntries object.
     * @param batchDictionaryEntries.dictionaryName - Dictionary type in which to search.
     * @param batchDictionaryEntries.batchDictionaryEntriesParams - The batchDictionaryEntriesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    batchDictionaryEntries({ dictionaryName: t, batchDictionaryEntriesParams: e }, r) {
      if (!t)
        throw new Error("Parameter `dictionaryName` is required when calling `batchDictionaryEntries`.");
      if (!e)
        throw new Error("Parameter `batchDictionaryEntriesParams` is required when calling `batchDictionaryEntries`.");
      if (!e.requests)
        throw new Error(
          "Parameter `batchDictionaryEntriesParams.requests` is required when calling `batchDictionaryEntries`."
        );
      const n = {
        method: "POST",
        path: "/1/dictionaries/{dictionaryName}/batch".replace(
          "{dictionaryName}",
          encodeURIComponent(t)
        ),
        queryParameters: {},
        headers: {},
        data: e
      };
      return l.request(n, r);
    },
    /**
     * Retrieves records from an index, up to 1,000 per request.  While searching retrieves _hits_ (records augmented with attributes for highlighting and ranking details), browsing _just_ returns matching records. This can be useful if you want to export your indices.  - The Analytics API doesn\'t collect data when using `browse`. - Records are ranked by attributes and custom ranking. - There\'s no ranking for: typo-tolerance, number of matched words, proximity, geo distance.  Browse requests automatically apply these settings:  - `advancedSyntax`: `false` - `attributesToHighlight`: `[]` - `attributesToSnippet`: `[]` - `distinct`: `false` - `enablePersonalization`: `false` - `enableRules`: `false` - `facets`: `[]` - `getRankingInfo`: `false` - `ignorePlurals`: `false` - `optionalFilters`: `[]` - `typoTolerance`: `true` or `false` (`min` and `strict` evaluate to `true`)  If you send these parameters with your browse requests, they\'ll be ignored.
     *
     * Required API Key ACLs:
     *  - browse
     * @param browse - The browse object.
     * @param browse.indexName - Name of the index on which to perform the operation.
     * @param browse.browseParams - The browseParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    browse({ indexName: t, browseParams: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `browse`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}/browse".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e || {},
        useReadTransporter: !0
      };
      return l.request(n, r);
    },
    /**
     * Deletes only the records from an index while keeping settings, synonyms, and rules. This operation is resource-intensive and subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param clearObjects - The clearObjects object.
     * @param clearObjects.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    clearObjects({ indexName: t }, e) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `clearObjects`.");
      const o = {
        method: "POST",
        path: "/1/indexes/{indexName}/clear".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Deletes all rules from the index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param clearRules - The clearRules object.
     * @param clearRules.indexName - Name of the index on which to perform the operation.
     * @param clearRules.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    clearRules({ indexName: t, forwardToReplicas: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `clearRules`.");
      const a = "/1/indexes/{indexName}/rules/clear".replace("{indexName}", encodeURIComponent(t)), s = {}, o = {};
      e !== void 0 && (o.forwardToReplicas = e.toString());
      const n = {
        method: "POST",
        path: a,
        queryParameters: o,
        headers: s
      };
      return l.request(n, r);
    },
    /**
     * Deletes all synonyms from the index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param clearSynonyms - The clearSynonyms object.
     * @param clearSynonyms.indexName - Name of the index on which to perform the operation.
     * @param clearSynonyms.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    clearSynonyms({ indexName: t, forwardToReplicas: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `clearSynonyms`.");
      const a = "/1/indexes/{indexName}/synonyms/clear".replace("{indexName}", encodeURIComponent(t)), s = {}, o = {};
      e !== void 0 && (o.forwardToReplicas = e.toString());
      const n = {
        method: "POST",
        path: a,
        queryParameters: o,
        headers: s
      };
      return l.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: t, parameters: e }, r) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const n = {
        method: "DELETE",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: t, parameters: e }, r) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const n = {
        method: "GET",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: t, parameters: e, body: r }, a) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const i = {
        method: "POST",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {},
        data: r || {}
      };
      return l.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: t, parameters: e, body: r }, a) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const i = {
        method: "PUT",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {},
        data: r || {}
      };
      return l.request(i, a);
    },
    /**
     * Deletes the API key.
     *
     * Required API Key ACLs:
     *  - admin
     * @param deleteApiKey - The deleteApiKey object.
     * @param deleteApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteApiKey({ key: t }, e) {
      if (!t)
        throw new Error("Parameter `key` is required when calling `deleteApiKey`.");
      const o = {
        method: "DELETE",
        path: "/1/keys/{key}".replace("{key}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * This operation doesn\'t accept empty filters.  This operation is resource-intensive. You should only use it if you can\'t get the object IDs of the records you want to delete. It\'s more efficient to get a list of object IDs with the [`browse` operation](https://www.algolia.com/doc/rest-api/search/browse), and then delete the records using the [`batch` operation](https://www.algolia.com/doc/rest-api/search/batch).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param deleteBy - The deleteBy object.
     * @param deleteBy.indexName - Name of the index on which to perform the operation.
     * @param deleteBy.deleteByParams - The deleteByParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteBy({ indexName: t, deleteByParams: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `deleteBy`.");
      if (!e)
        throw new Error("Parameter `deleteByParams` is required when calling `deleteBy`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}/deleteByQuery".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e
      };
      return l.request(n, r);
    },
    /**
     * Deletes an index and all its settings.  - Deleting an index doesn\'t delete its analytics data. - If you try to delete a non-existing index, the operation is ignored without warning. - If the index you want to delete has replica indices, the replicas become independent indices. - If the index you want to delete is a replica index, you must first unlink it from its primary index before you can delete it.   For more information, see [Delete replica indices](https://www.algolia.com/doc/guides/managing-results/refine-results/sorting/how-to/deleting-replicas).
     *
     * Required API Key ACLs:
     *  - deleteIndex
     * @param deleteIndex - The deleteIndex object.
     * @param deleteIndex.indexName - Name of the index on which to perform the operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteIndex({ indexName: t }, e) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `deleteIndex`.");
      const o = {
        method: "DELETE",
        path: "/1/indexes/{indexName}".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Deletes a record by its object ID.  To delete more than one record, use the [`batch` operation](https://www.algolia.com/doc/rest-api/search/batch). To delete records matching a query, use the [`deleteBy` operation](https://www.algolia.com/doc/rest-api/search/delete-by).
     *
     * Required API Key ACLs:
     *  - deleteObject
     * @param deleteObject - The deleteObject object.
     * @param deleteObject.indexName - Name of the index on which to perform the operation.
     * @param deleteObject.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteObject({ indexName: t, objectID: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `deleteObject`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `deleteObject`.");
      const n = {
        method: "DELETE",
        path: "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * Deletes a rule by its ID. To find the object ID for rules, use the [`search` operation](https://www.algolia.com/doc/rest-api/search/search-rules).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteRule - The deleteRule object.
     * @param deleteRule.indexName - Name of the index on which to perform the operation.
     * @param deleteRule.objectID - Unique identifier of a rule object.
     * @param deleteRule.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteRule({ indexName: t, objectID: e, forwardToReplicas: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `deleteRule`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `deleteRule`.");
      const s = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)), o = {}, n = {};
      r !== void 0 && (n.forwardToReplicas = r.toString());
      const i = {
        method: "DELETE",
        path: s,
        queryParameters: n,
        headers: o
      };
      return l.request(i, a);
    },
    /**
     * Deletes a source from the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param deleteSource - The deleteSource object.
     * @param deleteSource.source - IP address range of the source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteSource({ source: t }, e) {
      if (!t)
        throw new Error("Parameter `source` is required when calling `deleteSource`.");
      const o = {
        method: "DELETE",
        path: "/1/security/sources/{source}".replace("{source}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Deletes a synonym by its ID. To find the object IDs of your synonyms, use the [`search` operation](https://www.algolia.com/doc/rest-api/search/search-synonyms).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteSynonym - The deleteSynonym object.
     * @param deleteSynonym.indexName - Name of the index on which to perform the operation.
     * @param deleteSynonym.objectID - Unique identifier of a synonym object.
     * @param deleteSynonym.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteSynonym({ indexName: t, objectID: e, forwardToReplicas: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `deleteSynonym`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `deleteSynonym`.");
      const s = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)), o = {}, n = {};
      r !== void 0 && (n.forwardToReplicas = r.toString());
      const i = {
        method: "DELETE",
        path: s,
        queryParameters: n,
        headers: o
      };
      return l.request(i, a);
    },
    /**
     * Gets the permissions and restrictions of an API key.  When authenticating with the admin API key, you can request information for any of your application\'s keys. When authenticating with other API keys, you can only retrieve information for that key, with the description replaced by `<redacted>`.
     *
     * Required API Key ACLs:
     *  - search
     * @param getApiKey - The getApiKey object.
     * @param getApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getApiKey({ key: t }, e) {
      if (!t)
        throw new Error("Parameter `key` is required when calling `getApiKey`.");
      const o = {
        method: "GET",
        path: "/1/keys/{key}".replace("{key}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Checks the status of a given application task.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param getAppTask - The getAppTask object.
     * @param getAppTask.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getAppTask({ taskID: t }, e) {
      if (!t)
        throw new Error("Parameter `taskID` is required when calling `getAppTask`.");
      const o = {
        method: "GET",
        path: "/1/task/{taskID}".replace("{taskID}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Lists supported languages with their supported dictionary types and number of custom entries.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getDictionaryLanguages(t) {
      const s = {
        method: "GET",
        path: "/1/dictionaries/*/languages",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * Retrieves the languages for which standard dictionary entries are turned off.
     *
     * Required API Key ACLs:
     *  - settings
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getDictionarySettings(t) {
      const s = {
        method: "GET",
        path: "/1/dictionaries/*/settings",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * The request must be authenticated by an API key with the [`logs` ACL](https://www.algolia.com/doc/guides/security/api-keys/#access-control-list-acl).  - Logs are held for the last seven days. - Up to 1,000 API requests per server are logged. - This request counts towards your [operations quota](https://support.algolia.com/hc/articles/17245378392977-How-does-Algolia-count-records-and-operations) but doesn\'t appear in the logs itself.
     *
     * Required API Key ACLs:
     *  - logs
     * @param getLogs - The getLogs object.
     * @param getLogs.offset - First log entry to retrieve. The most recent entries are listed first.
     * @param getLogs.length - Maximum number of entries to retrieve.
     * @param getLogs.indexName - Index for which to retrieve log entries. By default, log entries are retrieved for all indices.
     * @param getLogs.type - Type of log entries to retrieve. By default, all log entries are retrieved.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getLogs({ offset: t, length: e, indexName: r, type: a } = {}, s = void 0) {
      const o = "/1/logs", n = {}, i = {};
      t !== void 0 && (i.offset = t.toString()), e !== void 0 && (i.length = e.toString()), r !== void 0 && (i.indexName = r.toString()), a !== void 0 && (i.type = a.toString());
      const d = {
        method: "GET",
        path: o,
        queryParameters: i,
        headers: n
      };
      return l.request(d, s);
    },
    /**
     * Retrieves one record by its object ID.  To retrieve more than one record, use the [`objects` operation](https://www.algolia.com/doc/rest-api/search/get-objects).
     *
     * Required API Key ACLs:
     *  - search
     * @param getObject - The getObject object.
     * @param getObject.indexName - Name of the index on which to perform the operation.
     * @param getObject.objectID - Unique record identifier.
     * @param getObject.attributesToRetrieve - Attributes to include with the records in the response. This is useful to reduce the size of the API response. By default, all retrievable attributes are returned.  `objectID` is always retrieved.  Attributes included in `unretrievableAttributes` won\'t be retrieved unless the request is authenticated with the admin API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getObject({ indexName: t, objectID: e, attributesToRetrieve: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `getObject`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `getObject`.");
      const s = "/1/indexes/{indexName}/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)), o = {}, n = {};
      r !== void 0 && (n.attributesToRetrieve = r.toString());
      const i = {
        method: "GET",
        path: s,
        queryParameters: n,
        headers: o
      };
      return l.request(i, a);
    },
    /**
     * Retrieves one or more records, potentially from different indices.  Records are returned in the same order as the requests.
     *
     * Required API Key ACLs:
     *  - search
     * @param getObjectsParams - Request object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getObjects(t, e) {
      if (!t)
        throw new Error("Parameter `getObjectsParams` is required when calling `getObjects`.");
      if (!t.requests)
        throw new Error("Parameter `getObjectsParams.requests` is required when calling `getObjects`.");
      const o = {
        method: "POST",
        path: "/1/indexes/*/objects",
        queryParameters: {},
        headers: {},
        data: t,
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(o, e);
    },
    /**
     * Retrieves a rule by its ID. To find the object ID of rules, use the [`search` operation](https://www.algolia.com/doc/rest-api/search/search-rules).
     *
     * Required API Key ACLs:
     *  - settings
     * @param getRule - The getRule object.
     * @param getRule.indexName - Name of the index on which to perform the operation.
     * @param getRule.objectID - Unique identifier of a rule object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRule({ indexName: t, objectID: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `getRule`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `getRule`.");
      const n = {
        method: "GET",
        path: "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * Retrieves an object with non-null index settings.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getSettings - The getSettings object.
     * @param getSettings.indexName - Name of the index on which to perform the operation.
     * @param getSettings.getVersion - When set to 2, the endpoint will not include `synonyms` in the response. This parameter is here for backward compatibility.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getSettings({ indexName: t, getVersion: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `getSettings`.");
      const a = "/1/indexes/{indexName}/settings".replace("{indexName}", encodeURIComponent(t)), s = {}, o = {};
      e !== void 0 && (o.getVersion = e.toString());
      const n = {
        method: "GET",
        path: a,
        queryParameters: o,
        headers: s
      };
      return l.request(n, r);
    },
    /**
     * Retrieves all allowed IP addresses with access to your application.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getSources(t) {
      const s = {
        method: "GET",
        path: "/1/security/sources",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * Retrieves a synonym by its ID. To find the object IDs for your synonyms, use the [`search` operation](https://www.algolia.com/doc/rest-api/search/search-synonyms).
     *
     * Required API Key ACLs:
     *  - settings
     * @param getSynonym - The getSynonym object.
     * @param getSynonym.indexName - Name of the index on which to perform the operation.
     * @param getSynonym.objectID - Unique identifier of a synonym object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getSynonym({ indexName: t, objectID: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `getSynonym`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `getSynonym`.");
      const n = {
        method: "GET",
        path: "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * Checks the status of a given task.  Indexing tasks are asynchronous. When you add, update, or delete records or indices, a task is created on a queue and completed depending on the load on the server.  The indexing tasks\' responses include a task ID that you can use to check the status.
     *
     * Required API Key ACLs:
     *  - addObject
     * @param getTask - The getTask object.
     * @param getTask.indexName - Name of the index on which to perform the operation.
     * @param getTask.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTask({ indexName: t, taskID: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `getTask`.");
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `getTask`.");
      const n = {
        method: "GET",
        path: "/1/indexes/{indexName}/task/{taskID}".replace("{indexName}", encodeURIComponent(t)).replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * Get the IDs of the 10 users with the highest number of records per cluster.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTopUserIds(t) {
      const s = {
        method: "GET",
        path: "/1/clusters/mapping/top",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * Returns the user ID data stored in the mapping.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param getUserId - The getUserId object.
     * @param getUserId.userID - Unique identifier of the user who makes the search request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getUserId({ userID: t }, e) {
      if (!t)
        throw new Error("Parameter `userID` is required when calling `getUserId`.");
      const o = {
        method: "GET",
        path: "/1/clusters/mapping/{userID}".replace("{userID}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * To determine when the time-consuming process of creating a large batch of users or migrating users from one cluster to another is complete, this operation retrieves the status of the process.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param hasPendingMappings - The hasPendingMappings object.
     * @param hasPendingMappings.getClusters - Whether to include the cluster\'s pending mapping state in the response.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    hasPendingMappings({ getClusters: t } = {}, e = void 0) {
      const r = "/1/clusters/mapping/pending", a = {}, s = {};
      t !== void 0 && (s.getClusters = t.toString());
      const o = {
        method: "GET",
        path: r,
        queryParameters: s,
        headers: a
      };
      return l.request(o, e);
    },
    /**
     * Lists all API keys associated with your Algolia application, including their permissions and restrictions.
     *
     * Required API Key ACLs:
     *  - admin
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listApiKeys(t) {
      const s = {
        method: "GET",
        path: "/1/keys",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * Lists the available clusters in a multi-cluster setup.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listClusters(t) {
      const s = {
        method: "GET",
        path: "/1/clusters",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * Lists all indices in the current Algolia application.  The request follows any index restrictions of the API key you use to make the request.
     *
     * Required API Key ACLs:
     *  - listIndexes
     * @param listIndices - The listIndices object.
     * @param listIndices.page - Requested page of the API response. If `null`, the API response is not paginated.
     * @param listIndices.hitsPerPage - Number of hits per page.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listIndices({ page: t, hitsPerPage: e } = {}, r = void 0) {
      const a = "/1/indexes", s = {}, o = {};
      t !== void 0 && (o.page = t.toString()), e !== void 0 && (o.hitsPerPage = e.toString());
      const n = {
        method: "GET",
        path: a,
        queryParameters: o,
        headers: s
      };
      return l.request(n, r);
    },
    /**
     * Lists the userIDs assigned to a multi-cluster application.  Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param listUserIds - The listUserIds object.
     * @param listUserIds.page - Requested page of the API response. If `null`, the API response is not paginated.
     * @param listUserIds.hitsPerPage - Number of hits per page.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listUserIds({ page: t, hitsPerPage: e } = {}, r = void 0) {
      const a = "/1/clusters/mapping", s = {}, o = {};
      t !== void 0 && (o.page = t.toString()), e !== void 0 && (o.hitsPerPage = e.toString());
      const n = {
        method: "GET",
        path: a,
        queryParameters: o,
        headers: s
      };
      return l.request(n, r);
    },
    /**
     * Adds, updates, or deletes records in multiple indices with a single API request.  - Actions are applied in the order they are specified. - Actions are equivalent to the individual API requests of the same name.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param batchParams - The batchParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    multipleBatch(t, e) {
      if (!t)
        throw new Error("Parameter `batchParams` is required when calling `multipleBatch`.");
      if (!t.requests)
        throw new Error("Parameter `batchParams.requests` is required when calling `multipleBatch`.");
      const o = {
        method: "POST",
        path: "/1/indexes/*/batch",
        queryParameters: {},
        headers: {},
        data: t
      };
      return l.request(o, e);
    },
    /**
     * Copies or moves (renames) an index within the same Algolia application.  - Existing destination indices are overwritten, except for their analytics data. - If the destination index doesn\'t exist yet, it\'ll be created. - This operation is resource-intensive.  **Copy**  - Copying a source index that doesn\'t exist creates a new index with 0 records and default settings. - The API keys of the source index are merged with the existing keys in the destination index. - You can\'t copy the `enableReRanking`, `mode`, and `replicas` settings. - You can\'t copy to a destination index that already has replicas. - Be aware of the [size limits](https://www.algolia.com/doc/guides/scaling/algolia-service-limits/#application-record-and-index-limits). - Related guide: [Copy indices](https://www.algolia.com/doc/guides/sending-and-managing-data/manage-indices-and-apps/manage-indices/how-to/copy-indices)  **Move**  - Moving a source index that doesn\'t exist is ignored without returning an error. - When moving an index, the analytics data keeps its original name, and a new set of analytics data is started for the new name.   To access the original analytics in the dashboard, create an index with the original name. - If the destination index has replicas, moving will overwrite the existing index and copy the data to the replica indices. - Related guide: [Move indices](https://www.algolia.com/doc/guides/sending-and-managing-data/manage-indices-and-apps/manage-indices/how-to/move-indices).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param operationIndex - The operationIndex object.
     * @param operationIndex.indexName - Name of the index on which to perform the operation.
     * @param operationIndex.operationIndexParams - The operationIndexParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    operationIndex({ indexName: t, operationIndexParams: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `operationIndex`.");
      if (!e)
        throw new Error("Parameter `operationIndexParams` is required when calling `operationIndex`.");
      if (!e.operation)
        throw new Error("Parameter `operationIndexParams.operation` is required when calling `operationIndex`.");
      if (!e.destination)
        throw new Error("Parameter `operationIndexParams.destination` is required when calling `operationIndex`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}/operation".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e
      };
      return l.request(n, r);
    },
    /**
     * Adds new attributes to a record, or updates existing ones.  - If a record with the specified object ID doesn\'t exist,   a new record is added to the index **if** `createIfNotExists` is true. - If the index doesn\'t exist yet, this method creates a new index. - You can use any first-level attribute but not nested attributes.   If you specify a nested attribute, this operation replaces its first-level ancestor.  To update an attribute without pushing the entire record, you can use these built-in operations. These operations can be helpful if you don\'t have access to your initial data.  - Increment: increment a numeric attribute - Decrement: decrement a numeric attribute - Add: append a number or string element to an array attribute - Remove: remove all matching number or string elements from an array attribute made of numbers or strings - AddUnique: add a number or string element to an array attribute made of numbers or strings only if it\'s not already present - IncrementFrom: increment a numeric integer attribute only if the provided value matches the current value, and otherwise ignore the whole object update. For example, if you pass an IncrementFrom value of 2 for the version attribute, but the current value of the attribute is 1, the engine ignores the update. If the object doesn\'t exist, the engine only creates it if you pass an IncrementFrom value of 0. - IncrementSet: increment a numeric integer attribute only if the provided value is greater than the current value, and otherwise ignore the whole object update. For example, if you pass an IncrementSet value of 2 for the version attribute, and the current value of the attribute is 1, the engine updates the object. If the object doesn\'t exist yet, the engine only creates it if you pass an IncrementSet value greater than 0.  You can specify an operation by providing an object with the attribute to update as the key and its value being an object with the following properties:  - _operation: the operation to apply on the attribute - value: the right-hand side argument to the operation, for example, increment or decrement step, value to add or remove.  When updating multiple attributes or using multiple operations targeting the same record, you should use a single partial update for faster processing.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param partialUpdateObject - The partialUpdateObject object.
     * @param partialUpdateObject.indexName - Name of the index on which to perform the operation.
     * @param partialUpdateObject.objectID - Unique record identifier.
     * @param partialUpdateObject.attributesToUpdate - Attributes with their values.
     * @param partialUpdateObject.createIfNotExists - Whether to create a new record if it doesn\'t exist.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    partialUpdateObject({ indexName: t, objectID: e, attributesToUpdate: r, createIfNotExists: a }, s) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `partialUpdateObject`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `partialUpdateObject`.");
      if (!r)
        throw new Error("Parameter `attributesToUpdate` is required when calling `partialUpdateObject`.");
      const o = "/1/indexes/{indexName}/{objectID}/partial".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)), n = {}, i = {};
      a !== void 0 && (i.createIfNotExists = a.toString());
      const d = {
        method: "POST",
        path: o,
        queryParameters: i,
        headers: n,
        data: r
      };
      return l.request(d, s);
    },
    /**
     * Deletes a user ID and its associated data from the clusters.
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param removeUserId - The removeUserId object.
     * @param removeUserId.userID - Unique identifier of the user who makes the search request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    removeUserId({ userID: t }, e) {
      if (!t)
        throw new Error("Parameter `userID` is required when calling `removeUserId`.");
      const o = {
        method: "DELETE",
        path: "/1/clusters/mapping/{userID}".replace("{userID}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Replaces the list of allowed sources.
     *
     * Required API Key ACLs:
     *  - admin
     * @param replaceSources - The replaceSources object.
     * @param replaceSources.source - Allowed sources.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    replaceSources({ source: t }, e) {
      if (!t)
        throw new Error("Parameter `source` is required when calling `replaceSources`.");
      const o = {
        method: "PUT",
        path: "/1/security/sources",
        queryParameters: {},
        headers: {},
        data: t
      };
      return l.request(o, e);
    },
    /**
     * Restores a deleted API key.  Restoring resets the `validity` attribute to `0`.  Algolia stores up to 1,000 API keys per application. If you create more, the oldest API keys are deleted and can\'t be restored.
     *
     * Required API Key ACLs:
     *  - admin
     * @param restoreApiKey - The restoreApiKey object.
     * @param restoreApiKey.key - API key.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    restoreApiKey({ key: t }, e) {
      if (!t)
        throw new Error("Parameter `key` is required when calling `restoreApiKey`.");
      const o = {
        method: "POST",
        path: "/1/keys/{key}/restore".replace("{key}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Adds a record to an index or replaces it.  - If the record doesn\'t have an object ID, a new record with an auto-generated object ID is added to your index. - If a record with the specified object ID exists, the existing record is replaced. - If a record with the specified object ID doesn\'t exist, a new record is added to your index. - If you add a record to an index that doesn\'t exist yet, a new index is created.  To update _some_ attributes of a record, use the [`partial` operation](https://www.algolia.com/doc/rest-api/search/partial-update-object). To add, update, or replace multiple records, use the [`batch` operation](https://www.algolia.com/doc/rest-api/search/batch).  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - addObject
     * @param saveObject - The saveObject object.
     * @param saveObject.indexName - Name of the index on which to perform the operation.
     * @param saveObject.body - The record. A schemaless object with attributes that are useful in the context of search and discovery.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    saveObject({ indexName: t, body: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `saveObject`.");
      if (!e)
        throw new Error("Parameter `body` is required when calling `saveObject`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e
      };
      return l.request(n, r);
    },
    /**
     * If a rule with the specified object ID doesn\'t exist, it\'s created. Otherwise, the existing rule is replaced.  To create or update more than one rule, use the [`batch` operation](https://www.algolia.com/doc/rest-api/search/save-rules).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveRule - The saveRule object.
     * @param saveRule.indexName - Name of the index on which to perform the operation.
     * @param saveRule.objectID - Unique identifier of a rule object.
     * @param saveRule.rule - The rule object.
     * @param saveRule.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    saveRule({ indexName: t, objectID: e, rule: r, forwardToReplicas: a }, s) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `saveRule`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `saveRule`.");
      if (!r)
        throw new Error("Parameter `rule` is required when calling `saveRule`.");
      if (!r.objectID)
        throw new Error("Parameter `rule.objectID` is required when calling `saveRule`.");
      if (!r.consequence)
        throw new Error("Parameter `rule.consequence` is required when calling `saveRule`.");
      const o = "/1/indexes/{indexName}/rules/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)), n = {}, i = {};
      a !== void 0 && (i.forwardToReplicas = a.toString());
      const d = {
        method: "PUT",
        path: o,
        queryParameters: i,
        headers: n,
        data: r
      };
      return l.request(d, s);
    },
    /**
     * Create or update multiple rules.  If a rule with the specified object ID doesn\'t exist, Algolia creates a new one. Otherwise, existing rules are replaced.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveRules - The saveRules object.
     * @param saveRules.indexName - Name of the index on which to perform the operation.
     * @param saveRules.rules - The rules object.
     * @param saveRules.forwardToReplicas - Whether changes are applied to replica indices.
     * @param saveRules.clearExistingRules - Whether existing rules should be deleted before adding this batch.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    saveRules({ indexName: t, rules: e, forwardToReplicas: r, clearExistingRules: a }, s) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `saveRules`.");
      if (!e)
        throw new Error("Parameter `rules` is required when calling `saveRules`.");
      const o = "/1/indexes/{indexName}/rules/batch".replace("{indexName}", encodeURIComponent(t)), n = {}, i = {};
      r !== void 0 && (i.forwardToReplicas = r.toString()), a !== void 0 && (i.clearExistingRules = a.toString());
      const d = {
        method: "POST",
        path: o,
        queryParameters: i,
        headers: n,
        data: e
      };
      return l.request(d, s);
    },
    /**
     * If a synonym with the specified object ID doesn\'t exist, Algolia adds a new one. Otherwise, the existing synonym is replaced. To add multiple synonyms in a single API request, use the [`batch` operation](https://www.algolia.com/doc/rest-api/search/save-synonyms).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveSynonym - The saveSynonym object.
     * @param saveSynonym.indexName - Name of the index on which to perform the operation.
     * @param saveSynonym.objectID - Unique identifier of a synonym object.
     * @param saveSynonym.synonymHit - The synonymHit object.
     * @param saveSynonym.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    saveSynonym({ indexName: t, objectID: e, synonymHit: r, forwardToReplicas: a }, s) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `saveSynonym`.");
      if (!e)
        throw new Error("Parameter `objectID` is required when calling `saveSynonym`.");
      if (!r)
        throw new Error("Parameter `synonymHit` is required when calling `saveSynonym`.");
      if (!r.objectID)
        throw new Error("Parameter `synonymHit.objectID` is required when calling `saveSynonym`.");
      if (!r.type)
        throw new Error("Parameter `synonymHit.type` is required when calling `saveSynonym`.");
      const o = "/1/indexes/{indexName}/synonyms/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{objectID}", encodeURIComponent(e)), n = {}, i = {};
      a !== void 0 && (i.forwardToReplicas = a.toString());
      const d = {
        method: "PUT",
        path: o,
        queryParameters: i,
        headers: n,
        data: r
      };
      return l.request(d, s);
    },
    /**
     * If a synonym with the `objectID` doesn\'t exist, Algolia adds a new one. Otherwise, existing synonyms are replaced.  This operation is subject to [indexing rate limits](https://support.algolia.com/hc/articles/4406975251089-Is-there-a-rate-limit-for-indexing-on-Algolia).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param saveSynonyms - The saveSynonyms object.
     * @param saveSynonyms.indexName - Name of the index on which to perform the operation.
     * @param saveSynonyms.synonymHit - The synonymHit object.
     * @param saveSynonyms.forwardToReplicas - Whether changes are applied to replica indices.
     * @param saveSynonyms.replaceExistingSynonyms - Whether to replace all synonyms in the index with the ones sent with this request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    saveSynonyms({ indexName: t, synonymHit: e, forwardToReplicas: r, replaceExistingSynonyms: a }, s) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `saveSynonyms`.");
      if (!e)
        throw new Error("Parameter `synonymHit` is required when calling `saveSynonyms`.");
      const o = "/1/indexes/{indexName}/synonyms/batch".replace("{indexName}", encodeURIComponent(t)), n = {}, i = {};
      r !== void 0 && (i.forwardToReplicas = r.toString()), a !== void 0 && (i.replaceExistingSynonyms = a.toString());
      const d = {
        method: "POST",
        path: o,
        queryParameters: i,
        headers: n,
        data: e
      };
      return l.request(d, s);
    },
    /**
     * Sends multiple search requests to one or more indices.  This can be useful in these cases:  - Different indices for different purposes, such as, one index for products, another one for marketing content. - Multiple searches to the same index—for example, with different filters.  Use the helper `searchForHits` or `searchForFacets` to get the results in a more convenient format, if you already know the return type you want.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchMethodParams - Muli-search request body. Results are returned in the same order as the requests.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    search(t, e) {
      if (t && Array.isArray(t) && (t = {
        requests: t.map(({ params: i, ...d }) => d.type === "facet" ? {
          ...d,
          ...i,
          type: "facet"
        } : {
          ...d,
          ...i,
          facet: void 0,
          maxFacetHits: void 0,
          facetQuery: void 0
        })
      }), !t)
        throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
      if (!t.requests)
        throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
      const o = {
        method: "POST",
        path: "/1/indexes/*/queries",
        queryParameters: {},
        headers: {},
        data: t,
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(o, e);
    },
    /**
     * Searches for standard and custom dictionary entries.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchDictionaryEntries - The searchDictionaryEntries object.
     * @param searchDictionaryEntries.dictionaryName - Dictionary type in which to search.
     * @param searchDictionaryEntries.searchDictionaryEntriesParams - The searchDictionaryEntriesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchDictionaryEntries({ dictionaryName: t, searchDictionaryEntriesParams: e }, r) {
      if (!t)
        throw new Error("Parameter `dictionaryName` is required when calling `searchDictionaryEntries`.");
      if (!e)
        throw new Error(
          "Parameter `searchDictionaryEntriesParams` is required when calling `searchDictionaryEntries`."
        );
      if (!e.query)
        throw new Error(
          "Parameter `searchDictionaryEntriesParams.query` is required when calling `searchDictionaryEntries`."
        );
      const n = {
        method: "POST",
        path: "/1/dictionaries/{dictionaryName}/search".replace(
          "{dictionaryName}",
          encodeURIComponent(t)
        ),
        queryParameters: {},
        headers: {},
        data: e,
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(n, r);
    },
    /**
     * Searches for values of a specified facet attribute.  - By default, facet values are sorted by decreasing count.   You can adjust this with the `sortFacetValueBy` parameter. - Searching for facet values doesn\'t work if you have **more than 65 searchable facets and searchable attributes combined**.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchForFacetValues - The searchForFacetValues object.
     * @param searchForFacetValues.indexName - Name of the index on which to perform the operation.
     * @param searchForFacetValues.facetName - Facet attribute in which to search for values.  This attribute must be included in the `attributesForFaceting` index setting with the `searchable()` modifier.
     * @param searchForFacetValues.searchForFacetValuesRequest - The searchForFacetValuesRequest object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchForFacetValues({ indexName: t, facetName: e, searchForFacetValuesRequest: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `searchForFacetValues`.");
      if (!e)
        throw new Error("Parameter `facetName` is required when calling `searchForFacetValues`.");
      const i = {
        method: "POST",
        path: "/1/indexes/{indexName}/facets/{facetName}/query".replace("{indexName}", encodeURIComponent(t)).replace("{facetName}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r || {},
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(i, a);
    },
    /**
     * Searches for rules in your index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchRules - The searchRules object.
     * @param searchRules.indexName - Name of the index on which to perform the operation.
     * @param searchRules.searchRulesParams - The searchRulesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchRules({ indexName: t, searchRulesParams: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `searchRules`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}/rules/search".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e || {},
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(n, r);
    },
    /**
     * Searches a single index and returns matching search results as hits.  This method lets you retrieve up to 1,000 hits. If you need more, use the [`browse` operation](https://www.algolia.com/doc/rest-api/search/browse) or increase the `paginatedLimitedTo` index setting.
     *
     * Required API Key ACLs:
     *  - search
     * @param searchSingleIndex - The searchSingleIndex object.
     * @param searchSingleIndex.indexName - Name of the index on which to perform the operation.
     * @param searchSingleIndex.searchParams - The searchParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchSingleIndex({ indexName: t, searchParams: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `searchSingleIndex`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}/query".replace("{indexName}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e || {},
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(n, r);
    },
    /**
     * Searches for synonyms in your index.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchSynonyms - The searchSynonyms object.
     * @param searchSynonyms.indexName - Name of the index on which to perform the operation.
     * @param searchSynonyms.searchSynonymsParams - Body of the `searchSynonyms` operation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchSynonyms({ indexName: t, searchSynonymsParams: e }, r) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `searchSynonyms`.");
      const n = {
        method: "POST",
        path: "/1/indexes/{indexName}/synonyms/search".replace(
          "{indexName}",
          encodeURIComponent(t)
        ),
        queryParameters: {},
        headers: {},
        data: e || {},
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(n, r);
    },
    /**
     * Since it can take a few seconds to get the data from the different clusters, the response isn\'t real-time.  To ensure rapid updates, the user IDs index isn\'t built at the same time as the mapping. Instead, it\'s built every 12 hours, at the same time as the update of user ID usage. For example, if you add or move a user ID, the search will show an old value until the next time the mapping is rebuilt (every 12 hours).
     *
     * Required API Key ACLs:
     *  - admin
     *
     * @deprecated
     * @param searchUserIdsParams - The searchUserIdsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchUserIds(t, e) {
      if (!t)
        throw new Error("Parameter `searchUserIdsParams` is required when calling `searchUserIds`.");
      if (!t.query)
        throw new Error("Parameter `searchUserIdsParams.query` is required when calling `searchUserIds`.");
      const o = {
        method: "POST",
        path: "/1/clusters/mapping/search",
        queryParameters: {},
        headers: {},
        data: t,
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(o, e);
    },
    /**
     * Turns standard stop word dictionary entries on or off for a given language.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param dictionarySettingsParams - The dictionarySettingsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    setDictionarySettings(t, e) {
      if (!t)
        throw new Error("Parameter `dictionarySettingsParams` is required when calling `setDictionarySettings`.");
      if (!t.disableStandardEntries)
        throw new Error(
          "Parameter `dictionarySettingsParams.disableStandardEntries` is required when calling `setDictionarySettings`."
        );
      const o = {
        method: "PUT",
        path: "/1/dictionaries/*/settings",
        queryParameters: {},
        headers: {},
        data: t
      };
      return l.request(o, e);
    },
    /**
     * Update the specified index settings.  Index settings that you don\'t specify are left unchanged. Specify `null` to reset a setting to its default value.  For best performance, update the index settings before you add new records to your index.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param setSettings - The setSettings object.
     * @param setSettings.indexName - Name of the index on which to perform the operation.
     * @param setSettings.indexSettings - The indexSettings object.
     * @param setSettings.forwardToReplicas - Whether changes are applied to replica indices.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    setSettings({ indexName: t, indexSettings: e, forwardToReplicas: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `setSettings`.");
      if (!e)
        throw new Error("Parameter `indexSettings` is required when calling `setSettings`.");
      const s = "/1/indexes/{indexName}/settings".replace("{indexName}", encodeURIComponent(t)), o = {}, n = {};
      r !== void 0 && (n.forwardToReplicas = r.toString());
      const i = {
        method: "PUT",
        path: s,
        queryParameters: n,
        headers: o,
        data: e
      };
      return l.request(i, a);
    },
    /**
     * Replaces the permissions of an existing API key.  Any unspecified attribute resets that attribute to its default value.
     *
     * Required API Key ACLs:
     *  - admin
     * @param updateApiKey - The updateApiKey object.
     * @param updateApiKey.key - API key.
     * @param updateApiKey.apiKey - The apiKey object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateApiKey({ key: t, apiKey: e }, r) {
      if (!t)
        throw new Error("Parameter `key` is required when calling `updateApiKey`.");
      if (!e)
        throw new Error("Parameter `apiKey` is required when calling `updateApiKey`.");
      if (!e.acl)
        throw new Error("Parameter `apiKey.acl` is required when calling `updateApiKey`.");
      const n = {
        method: "PUT",
        path: "/1/keys/{key}".replace("{key}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {},
        data: e
      };
      return l.request(n, r);
    }
  };
}
function be(c, u, h) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  return pr({
    appId: c,
    apiKey: u,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${B}-${c}` }), E()]
    }),
    ...h
  });
}
const yr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apiClientVersion: B,
  searchClient: be
}, Symbol.toStringTag, { value: "Module" }));
var Z = "1.44.0", qe = ["eu", "us"];
function Er(c) {
  return [{ url: "data.{region}.algolia.com".replace("{region}", c), accept: "readWrite", protocol: "https" }];
}
function vr(c) {
  return c.type === "onDemand";
}
function Sr(c) {
  return c.type === "schedule";
}
function Tr(c) {
  return c.type === "subscription";
}
function br({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  region: g,
  ...q
}) {
  const l = k(c, u, h), t = U({
    hosts: Er(g),
    ...q,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Ingestion",
      version: Z
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...l.headers(),
      ...q.baseHeaders
    },
    baseQueryParameters: {
      ...l.queryParameters(),
      ...q.baseQueryParameters
    }
  });
  return {
    transporter: t,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([t.requestsCache.clear(), t.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return t.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(e, r) {
      t.algoliaAgent.add({ segment: e, version: r });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: e }) {
      !h || h === "WithinHeaders" ? t.baseHeaders["x-algolia-api-key"] = e : t.baseQueryParameters["x-algolia-api-key"] = e;
    },
    /**
     * Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `push` requests by leveraging the Transformation pipeline setup in the Push connector (https://www.algolia.com/doc/guides/sending-and-managing-data/send-and-update-your-data/connectors/push/).
     *
     * @summary Helper: Chunks the given `objects` list in subset of 1000 elements max in order to make it fit in `batch` requests.
     * @param chunkedPush - The `chunkedPush` object.
     * @param chunkedPush.indexName - The `indexName` to replace `objects` in.
     * @param chunkedPush.objects - The array of `objects` to store in the given Algolia `indexName`.
     * @param chunkedPush.action - The `batch` `action` to perform on the given array of `objects`, defaults to `addObject`.
     * @param chunkedPush.waitForTasks - Whether or not we should wait until every `batch` tasks has been processed, this operation may slow the total execution time of this method but is more reliable.
     * @param chunkedPush.batchSize - The size of the chunk of `objects`. The number of `batch` calls will be equal to `length(objects) / batchSize`. Defaults to 1000.
     * @param chunkedPush.referenceIndexName - This is required when targeting an index that does not have a push connector setup (e.g. a tmp index), but you wish to attach another index's transformation to it (e.g. the source index name).
     * @param requestOptions - The requestOptions to send along with the query, they will be forwarded to the `getEvent` method and merged with the transporter requestOptions.
     */
    async chunkedPush({
      indexName: e,
      objects: r,
      action: a = "addObject",
      waitForTasks: s,
      batchSize: o = 1e3,
      referenceIndexName: n
    }, i) {
      let d = [], P = 0;
      const w = [], f = Math.floor(o / 10) || o, y = r.entries();
      for (const [p, v] of y)
        if (d.push(v), (d.length === o || p === r.length - 1) && (w.push(
          await this.push({ indexName: e, pushTaskPayload: { action: a, records: d }, referenceIndexName: n }, i)
        ), d = []), s && w.length > 0 && (w.length % f === 0 || p === r.length - 1)) {
          for (const S of w.slice(P, P + f)) {
            if (!S.eventID)
              throw new Error("received unexpected response from the push endpoint, eventID must not be undefined");
            let N = 0;
            await G({
              func: async () => {
                if (S.eventID === void 0 || !S.eventID)
                  throw new Error("received unexpected response from the push endpoint, eventID must not be undefined");
                return this.getEvent({ runID: S.runID, eventID: S.eventID }).catch((_) => {
                  if (_.status !== 404)
                    throw _;
                });
              },
              validate: (_) => _ !== void 0,
              aggregator: () => N += 1,
              error: {
                validate: () => N >= 50,
                message: () => `The maximum number of retries exceeded. (${N}/50)`
              },
              timeout: () => Math.min(N * 500, 5e3)
            });
          }
          P += f;
        }
      return w;
    },
    /**
     * Creates a new authentication resource.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param authenticationCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    createAuthentication(e, r) {
      if (!e)
        throw new Error("Parameter `authenticationCreate` is required when calling `createAuthentication`.");
      if (!e.type)
        throw new Error("Parameter `authenticationCreate.type` is required when calling `createAuthentication`.");
      if (!e.name)
        throw new Error("Parameter `authenticationCreate.name` is required when calling `createAuthentication`.");
      if (!e.input)
        throw new Error("Parameter `authenticationCreate.input` is required when calling `createAuthentication`.");
      const n = {
        method: "POST",
        path: "/1/authentications",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Creates a new destination.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param destinationCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    createDestination(e, r) {
      if (!e)
        throw new Error("Parameter `destinationCreate` is required when calling `createDestination`.");
      if (!e.type)
        throw new Error("Parameter `destinationCreate.type` is required when calling `createDestination`.");
      if (!e.name)
        throw new Error("Parameter `destinationCreate.name` is required when calling `createDestination`.");
      if (!e.input)
        throw new Error("Parameter `destinationCreate.input` is required when calling `createDestination`.");
      const n = {
        method: "POST",
        path: "/1/destinations",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Creates a new source.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    createSource(e, r) {
      if (!e)
        throw new Error("Parameter `sourceCreate` is required when calling `createSource`.");
      if (!e.type)
        throw new Error("Parameter `sourceCreate.type` is required when calling `createSource`.");
      if (!e.name)
        throw new Error("Parameter `sourceCreate.name` is required when calling `createSource`.");
      const n = {
        method: "POST",
        path: "/1/sources",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Creates a new task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param taskCreate - Request body for creating a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    createTask(e, r) {
      if (!e)
        throw new Error("Parameter `taskCreate` is required when calling `createTask`.");
      if (!e.sourceID)
        throw new Error("Parameter `taskCreate.sourceID` is required when calling `createTask`.");
      if (!e.destinationID)
        throw new Error("Parameter `taskCreate.destinationID` is required when calling `createTask`.");
      if (!e.action)
        throw new Error("Parameter `taskCreate.action` is required when calling `createTask`.");
      const n = {
        method: "POST",
        path: "/2/tasks",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Creates a new task using the v1 endpoint, please use `createTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param taskCreate - Request body for creating a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    createTaskV1(e, r) {
      if (!e)
        throw new Error("Parameter `taskCreate` is required when calling `createTaskV1`.");
      if (!e.sourceID)
        throw new Error("Parameter `taskCreate.sourceID` is required when calling `createTaskV1`.");
      if (!e.destinationID)
        throw new Error("Parameter `taskCreate.destinationID` is required when calling `createTaskV1`.");
      if (!e.trigger)
        throw new Error("Parameter `taskCreate.trigger` is required when calling `createTaskV1`.");
      if (!e.action)
        throw new Error("Parameter `taskCreate.action` is required when calling `createTaskV1`.");
      const n = {
        method: "POST",
        path: "/1/tasks",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Creates a new transformation.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param transformationCreate - Request body for creating a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    createTransformation(e, r) {
      if (!e)
        throw new Error("Parameter `transformationCreate` is required when calling `createTransformation`.");
      if (!e.name)
        throw new Error("Parameter `transformationCreate.name` is required when calling `createTransformation`.");
      const n = {
        method: "POST",
        path: "/1/transformations",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const i = {
        method: "DELETE",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: e, parameters: r }, a) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const i = {
        method: "GET",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const d = {
        method: "POST",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: e, parameters: r, body: a }, s) {
      if (!e)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const d = {
        method: "PUT",
        path: "/{path}".replace("{path}", e),
        queryParameters: r || {},
        headers: {},
        data: a || {}
      };
      return t.request(d, s);
    },
    /**
     * Deletes an authentication resource. You can\'t delete authentication resources that are used by a source or a destination.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteAuthentication - The deleteAuthentication object.
     * @param deleteAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteAuthentication({ authenticationID: e }, r) {
      if (!e)
        throw new Error("Parameter `authenticationID` is required when calling `deleteAuthentication`.");
      const n = {
        method: "DELETE",
        path: "/1/authentications/{authenticationID}".replace(
          "{authenticationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Deletes a destination by its ID. You can\'t delete destinations that are referenced in tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteDestination - The deleteDestination object.
     * @param deleteDestination.destinationID - Unique identifier of a destination.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteDestination({ destinationID: e }, r) {
      if (!e)
        throw new Error("Parameter `destinationID` is required when calling `deleteDestination`.");
      const n = {
        method: "DELETE",
        path: "/1/destinations/{destinationID}".replace(
          "{destinationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Deletes a source by its ID. You can\'t delete sources that are referenced in tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteSource - The deleteSource object.
     * @param deleteSource.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteSource({ sourceID: e }, r) {
      if (!e)
        throw new Error("Parameter `sourceID` is required when calling `deleteSource`.");
      const n = {
        method: "DELETE",
        path: "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Deletes a task by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteTask - The deleteTask object.
     * @param deleteTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteTask({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `deleteTask`.");
      const n = {
        method: "DELETE",
        path: "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Deletes a task by its ID using the v1 endpoint, please use `deleteTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param deleteTaskV1 - The deleteTaskV1 object.
     * @param deleteTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteTaskV1({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `deleteTaskV1`.");
      const n = {
        method: "DELETE",
        path: "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Deletes a transformation by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param deleteTransformation - The deleteTransformation object.
     * @param deleteTransformation.transformationID - Unique identifier of a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteTransformation({ transformationID: e }, r) {
      if (!e)
        throw new Error("Parameter `transformationID` is required when calling `deleteTransformation`.");
      const n = {
        method: "DELETE",
        path: "/1/transformations/{transformationID}".replace(
          "{transformationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Disables a task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param disableTask - The disableTask object.
     * @param disableTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    disableTask({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `disableTask`.");
      const n = {
        method: "PUT",
        path: "/2/tasks/{taskID}/disable".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Disables a task using the v1 endpoint, please use `disableTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param disableTaskV1 - The disableTaskV1 object.
     * @param disableTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    disableTaskV1({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `disableTaskV1`.");
      const n = {
        method: "PUT",
        path: "/1/tasks/{taskID}/disable".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Enables a task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param enableTask - The enableTask object.
     * @param enableTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    enableTask({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `enableTask`.");
      const n = {
        method: "PUT",
        path: "/2/tasks/{taskID}/enable".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Enables a task using the v1 endpoint, please use `enableTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param enableTaskV1 - The enableTaskV1 object.
     * @param enableTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    enableTaskV1({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `enableTaskV1`.");
      const n = {
        method: "PUT",
        path: "/1/tasks/{taskID}/enable".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves an authentication resource by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getAuthentication - The getAuthentication object.
     * @param getAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getAuthentication({ authenticationID: e }, r) {
      if (!e)
        throw new Error("Parameter `authenticationID` is required when calling `getAuthentication`.");
      const n = {
        method: "GET",
        path: "/1/authentications/{authenticationID}".replace(
          "{authenticationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves a destination by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getDestination - The getDestination object.
     * @param getDestination.destinationID - Unique identifier of a destination.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getDestination({ destinationID: e }, r) {
      if (!e)
        throw new Error("Parameter `destinationID` is required when calling `getDestination`.");
      const n = {
        method: "GET",
        path: "/1/destinations/{destinationID}".replace(
          "{destinationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves a single task run event by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getEvent - The getEvent object.
     * @param getEvent.runID - Unique identifier of a task run.
     * @param getEvent.eventID - Unique identifier of an event.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getEvent({ runID: e, eventID: r }, a) {
      if (!e)
        throw new Error("Parameter `runID` is required when calling `getEvent`.");
      if (!r)
        throw new Error("Parameter `eventID` is required when calling `getEvent`.");
      const i = {
        method: "GET",
        path: "/1/runs/{runID}/events/{eventID}".replace("{runID}", encodeURIComponent(e)).replace("{eventID}", encodeURIComponent(r)),
        queryParameters: {},
        headers: {}
      };
      return t.request(i, a);
    },
    /**
     * Retrieve a single task run by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getRun - The getRun object.
     * @param getRun.runID - Unique identifier of a task run.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRun({ runID: e }, r) {
      if (!e)
        throw new Error("Parameter `runID` is required when calling `getRun`.");
      const n = {
        method: "GET",
        path: "/1/runs/{runID}".replace("{runID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieve a source by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getSource - The getSource object.
     * @param getSource.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getSource({ sourceID: e }, r) {
      if (!e)
        throw new Error("Parameter `sourceID` is required when calling `getSource`.");
      const n = {
        method: "GET",
        path: "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves a task by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getTask - The getTask object.
     * @param getTask.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTask({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `getTask`.");
      const n = {
        method: "GET",
        path: "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves a task by its ID using the v1 endpoint, please use `getTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param getTaskV1 - The getTaskV1 object.
     * @param getTaskV1.taskID - Unique identifier of a task.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTaskV1({ taskID: e }, r) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `getTaskV1`.");
      const n = {
        method: "GET",
        path: "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves a transformation by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param getTransformation - The getTransformation object.
     * @param getTransformation.transformationID - Unique identifier of a transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getTransformation({ transformationID: e }, r) {
      if (!e)
        throw new Error("Parameter `transformationID` is required when calling `getTransformation`.");
      const n = {
        method: "GET",
        path: "/1/transformations/{transformationID}".replace(
          "{transformationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {}
      };
      return t.request(n, r);
    },
    /**
     * Retrieves a list of all authentication resources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listAuthentications - The listAuthentications object.
     * @param listAuthentications.itemsPerPage - Number of items per page.
     * @param listAuthentications.page - Page number of the paginated API response.
     * @param listAuthentications.type - Type of authentication resource to retrieve.
     * @param listAuthentications.platform - Ecommerce platform for which to retrieve authentications.
     * @param listAuthentications.sort - Property by which to sort the list of authentications.
     * @param listAuthentications.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listAuthentications({ itemsPerPage: e, page: r, type: a, platform: s, sort: o, order: n } = {}, i = void 0) {
      const d = "/1/authentications", P = {}, w = {};
      e !== void 0 && (w.itemsPerPage = e.toString()), r !== void 0 && (w.page = r.toString()), a !== void 0 && (w.type = a.toString()), s !== void 0 && (w.platform = s.toString()), o !== void 0 && (w.sort = o.toString()), n !== void 0 && (w.order = n.toString());
      const f = {
        method: "GET",
        path: d,
        queryParameters: w,
        headers: P
      };
      return t.request(f, i);
    },
    /**
     * Retrieves a list of destinations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listDestinations - The listDestinations object.
     * @param listDestinations.itemsPerPage - Number of items per page.
     * @param listDestinations.page - Page number of the paginated API response.
     * @param listDestinations.type - Destination type.
     * @param listDestinations.authenticationID - Authentication ID used by destinations.
     * @param listDestinations.transformationID - Get the list of destinations used by a transformation.
     * @param listDestinations.sort - Property by which to sort the destinations.
     * @param listDestinations.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listDestinations({ itemsPerPage: e, page: r, type: a, authenticationID: s, transformationID: o, sort: n, order: i } = {}, d = void 0) {
      const P = "/1/destinations", w = {}, f = {};
      e !== void 0 && (f.itemsPerPage = e.toString()), r !== void 0 && (f.page = r.toString()), a !== void 0 && (f.type = a.toString()), s !== void 0 && (f.authenticationID = s.toString()), o !== void 0 && (f.transformationID = o.toString()), n !== void 0 && (f.sort = n.toString()), i !== void 0 && (f.order = i.toString());
      const y = {
        method: "GET",
        path: P,
        queryParameters: f,
        headers: w
      };
      return t.request(y, d);
    },
    /**
     * Retrieves a list of events for a task run, identified by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listEvents - The listEvents object.
     * @param listEvents.runID - Unique identifier of a task run.
     * @param listEvents.itemsPerPage - Number of items per page.
     * @param listEvents.page - Page number of the paginated API response.
     * @param listEvents.status - Event status for filtering the list of task runs.
     * @param listEvents.type - Event type for filtering the list of task runs.
     * @param listEvents.sort - Property by which to sort the list of task run events.
     * @param listEvents.order - Sort order of the response, ascending or descending.
     * @param listEvents.startDate - Date and time in RFC 3339 format for the earliest events to retrieve. By default, the current time minus three hours is used.
     * @param listEvents.endDate - Date and time in RFC 3339 format for the latest events to retrieve. By default, the current time is used.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listEvents({ runID: e, itemsPerPage: r, page: a, status: s, type: o, sort: n, order: i, startDate: d, endDate: P }, w) {
      if (!e)
        throw new Error("Parameter `runID` is required when calling `listEvents`.");
      const f = "/1/runs/{runID}/events".replace("{runID}", encodeURIComponent(e)), y = {}, p = {};
      r !== void 0 && (p.itemsPerPage = r.toString()), a !== void 0 && (p.page = a.toString()), s !== void 0 && (p.status = s.toString()), o !== void 0 && (p.type = o.toString()), n !== void 0 && (p.sort = n.toString()), i !== void 0 && (p.order = i.toString()), d !== void 0 && (p.startDate = d.toString()), P !== void 0 && (p.endDate = P.toString());
      const v = {
        method: "GET",
        path: f,
        queryParameters: p,
        headers: y
      };
      return t.request(v, w);
    },
    /**
     * Retrieve a list of task runs.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listRuns - The listRuns object.
     * @param listRuns.itemsPerPage - Number of items per page.
     * @param listRuns.page - Page number of the paginated API response.
     * @param listRuns.status - Run status for filtering the list of task runs.
     * @param listRuns.type - Run type for filtering the list of task runs.
     * @param listRuns.taskID - Task ID for filtering the list of task runs.
     * @param listRuns.sort - Property by which to sort the list of task runs.
     * @param listRuns.order - Sort order of the response, ascending or descending.
     * @param listRuns.startDate - Date in RFC 3339 format for the earliest run to retrieve. By default, the current day minus seven days is used.
     * @param listRuns.endDate - Date in RFC 3339 format for the latest run to retrieve. By default, the current day is used.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listRuns({ itemsPerPage: e, page: r, status: a, type: s, taskID: o, sort: n, order: i, startDate: d, endDate: P } = {}, w = void 0) {
      const f = "/1/runs", y = {}, p = {};
      e !== void 0 && (p.itemsPerPage = e.toString()), r !== void 0 && (p.page = r.toString()), a !== void 0 && (p.status = a.toString()), s !== void 0 && (p.type = s.toString()), o !== void 0 && (p.taskID = o.toString()), n !== void 0 && (p.sort = n.toString()), i !== void 0 && (p.order = i.toString()), d !== void 0 && (p.startDate = d.toString()), P !== void 0 && (p.endDate = P.toString());
      const v = {
        method: "GET",
        path: f,
        queryParameters: p,
        headers: y
      };
      return t.request(v, w);
    },
    /**
     * Retrieves a list of sources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listSources - The listSources object.
     * @param listSources.itemsPerPage - Number of items per page.
     * @param listSources.page - Page number of the paginated API response.
     * @param listSources.type - Source type. Some sources require authentication.
     * @param listSources.authenticationID - Authentication IDs of the sources to retrieve. \'none\' returns sources that doesn\'t have an authentication.
     * @param listSources.sort - Property by which to sort the list of sources.
     * @param listSources.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listSources({ itemsPerPage: e, page: r, type: a, authenticationID: s, sort: o, order: n } = {}, i = void 0) {
      const d = "/1/sources", P = {}, w = {};
      e !== void 0 && (w.itemsPerPage = e.toString()), r !== void 0 && (w.page = r.toString()), a !== void 0 && (w.type = a.toString()), s !== void 0 && (w.authenticationID = s.toString()), o !== void 0 && (w.sort = o.toString()), n !== void 0 && (w.order = n.toString());
      const f = {
        method: "GET",
        path: d,
        queryParameters: w,
        headers: P
      };
      return t.request(f, i);
    },
    /**
     * Retrieves a list of tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listTasks - The listTasks object.
     * @param listTasks.itemsPerPage - Number of items per page.
     * @param listTasks.page - Page number of the paginated API response.
     * @param listTasks.action - Actions for filtering the list of tasks.
     * @param listTasks.enabled - Whether to filter the list of tasks by the `enabled` status.
     * @param listTasks.sourceID - Source IDs for filtering the list of tasks.
     * @param listTasks.sourceType - Filters the tasks with the specified source type.
     * @param listTasks.destinationID - Destination IDs for filtering the list of tasks.
     * @param listTasks.triggerType - Type of task trigger for filtering the list of tasks.
     * @param listTasks.withEmailNotifications - If specified, the response only includes tasks with notifications.email.enabled set to this value.
     * @param listTasks.sort - Property by which to sort the list of tasks.
     * @param listTasks.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listTasks({
      itemsPerPage: e,
      page: r,
      action: a,
      enabled: s,
      sourceID: o,
      sourceType: n,
      destinationID: i,
      triggerType: d,
      withEmailNotifications: P,
      sort: w,
      order: f
    } = {}, y = void 0) {
      const p = "/2/tasks", v = {}, S = {};
      e !== void 0 && (S.itemsPerPage = e.toString()), r !== void 0 && (S.page = r.toString()), a !== void 0 && (S.action = a.toString()), s !== void 0 && (S.enabled = s.toString()), o !== void 0 && (S.sourceID = o.toString()), n !== void 0 && (S.sourceType = n.toString()), i !== void 0 && (S.destinationID = i.toString()), d !== void 0 && (S.triggerType = d.toString()), P !== void 0 && (S.withEmailNotifications = P.toString()), w !== void 0 && (S.sort = w.toString()), f !== void 0 && (S.order = f.toString());
      const N = {
        method: "GET",
        path: p,
        queryParameters: S,
        headers: v
      };
      return t.request(N, y);
    },
    /**
     * Retrieves a list of tasks using the v1 endpoint, please use `getTasks` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param listTasksV1 - The listTasksV1 object.
     * @param listTasksV1.itemsPerPage - Number of items per page.
     * @param listTasksV1.page - Page number of the paginated API response.
     * @param listTasksV1.action - Actions for filtering the list of tasks.
     * @param listTasksV1.enabled - Whether to filter the list of tasks by the `enabled` status.
     * @param listTasksV1.sourceID - Source IDs for filtering the list of tasks.
     * @param listTasksV1.destinationID - Destination IDs for filtering the list of tasks.
     * @param listTasksV1.triggerType - Type of task trigger for filtering the list of tasks.
     * @param listTasksV1.sort - Property by which to sort the list of tasks.
     * @param listTasksV1.order - Sort order of the response, ascending or descending.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listTasksV1({ itemsPerPage: e, page: r, action: a, enabled: s, sourceID: o, destinationID: n, triggerType: i, sort: d, order: P } = {}, w = void 0) {
      const f = "/1/tasks", y = {}, p = {};
      e !== void 0 && (p.itemsPerPage = e.toString()), r !== void 0 && (p.page = r.toString()), a !== void 0 && (p.action = a.toString()), s !== void 0 && (p.enabled = s.toString()), o !== void 0 && (p.sourceID = o.toString()), n !== void 0 && (p.destinationID = n.toString()), i !== void 0 && (p.triggerType = i.toString()), d !== void 0 && (p.sort = d.toString()), P !== void 0 && (p.order = P.toString());
      const v = {
        method: "GET",
        path: f,
        queryParameters: p,
        headers: y
      };
      return t.request(v, w);
    },
    /**
     * Retrieves a list of transformations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param listTransformations - The listTransformations object.
     * @param listTransformations.itemsPerPage - Number of items per page.
     * @param listTransformations.page - Page number of the paginated API response.
     * @param listTransformations.sort - Property by which to sort the list of transformations.
     * @param listTransformations.order - Sort order of the response, ascending or descending.
     * @param listTransformations.type - Whether to filter the list of transformations by the type of transformation.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    listTransformations({ itemsPerPage: e, page: r, sort: a, order: s, type: o } = {}, n = void 0) {
      const i = "/1/transformations", d = {}, P = {};
      e !== void 0 && (P.itemsPerPage = e.toString()), r !== void 0 && (P.page = r.toString()), a !== void 0 && (P.sort = a.toString()), s !== void 0 && (P.order = s.toString()), o !== void 0 && (P.type = o.toString());
      const w = {
        method: "GET",
        path: i,
        queryParameters: P,
        headers: d
      };
      return t.request(w, n);
    },
    /**
     * Pushes records through the Pipeline, directly to an index. You can make the call synchronous by providing the `watch` parameter, for asynchronous calls, you can use the observability endpoints and/or debugger dashboard to see the status of your task. If you want to leverage the [pre-indexing data transformation](https://www.algolia.com/doc/guides/sending-and-managing-data/send-and-update-your-data/how-to/transform-your-data), this is the recommended way of ingesting your records. This method is similar to `pushTask`, but requires an `indexName` instead of a `taskID`. If zero or many tasks are found, an error will be returned.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param push - The push object.
     * @param push.indexName - Name of the index on which to perform the operation.
     * @param push.pushTaskPayload - The pushTaskPayload object.
     * @param push.watch - When provided, the push operation will be synchronous and the API will wait for the ingestion to be finished before responding.
     * @param push.referenceIndexName - This is required when targeting an index that does not have a push connector setup (e.g. a tmp index), but you wish to attach another index\'s transformation to it (e.g. the source index name).
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    push({ indexName: e, pushTaskPayload: r, watch: a, referenceIndexName: s }, o) {
      if (!e)
        throw new Error("Parameter `indexName` is required when calling `push`.");
      if (!r)
        throw new Error("Parameter `pushTaskPayload` is required when calling `push`.");
      if (!r.action)
        throw new Error("Parameter `pushTaskPayload.action` is required when calling `push`.");
      if (!r.records)
        throw new Error("Parameter `pushTaskPayload.records` is required when calling `push`.");
      const n = "/1/push/{indexName}".replace("{indexName}", encodeURIComponent(e)), i = {}, d = {};
      a !== void 0 && (d.watch = a.toString()), s !== void 0 && (d.referenceIndexName = s.toString());
      const P = {
        method: "POST",
        path: n,
        queryParameters: d,
        headers: i,
        data: r
      };
      return o = {
        timeouts: {
          connect: 18e4,
          read: 18e4,
          write: 18e4,
          ...o == null ? void 0 : o.timeouts
        }
      }, t.request(P, o);
    },
    /**
     * Pushes records through the pipeline, directly to an index. You can make the call synchronous by providing the `watch` parameter, for asynchronous calls, you can use the observability endpoints or the debugger dashboard to see the status of your task. If you want to transform your data before indexing, this is the recommended way of ingesting your records. This method is similar to `push`, but requires a `taskID` instead of a `indexName`, which is useful when many `destinations` target the same `indexName`.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param pushTask - The pushTask object.
     * @param pushTask.taskID - Unique identifier of a task.
     * @param pushTask.pushTaskPayload - The pushTaskPayload object.
     * @param pushTask.watch - When provided, the push operation will be synchronous and the API will wait for the ingestion to be finished before responding.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    pushTask({ taskID: e, pushTaskPayload: r, watch: a }, s) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `pushTask`.");
      if (!r)
        throw new Error("Parameter `pushTaskPayload` is required when calling `pushTask`.");
      if (!r.action)
        throw new Error("Parameter `pushTaskPayload.action` is required when calling `pushTask`.");
      if (!r.records)
        throw new Error("Parameter `pushTaskPayload.records` is required when calling `pushTask`.");
      const o = "/2/tasks/{taskID}/push".replace("{taskID}", encodeURIComponent(e)), n = {}, i = {};
      a !== void 0 && (i.watch = a.toString());
      const d = {
        method: "POST",
        path: o,
        queryParameters: i,
        headers: n,
        data: r
      };
      return s = {
        timeouts: {
          connect: 18e4,
          read: 18e4,
          write: 18e4,
          ...s == null ? void 0 : s.timeouts
        }
      }, t.request(d, s);
    },
    /**
     * Fully updates a task by its ID, use partialUpdateTask if you only want to update a subset of fields.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param replaceTask - The replaceTask object.
     * @param replaceTask.taskID - Unique identifier of a task.
     * @param replaceTask.taskReplace - The taskReplace object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    replaceTask({ taskID: e, taskReplace: r }, a) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `replaceTask`.");
      if (!r)
        throw new Error("Parameter `taskReplace` is required when calling `replaceTask`.");
      if (!r.destinationID)
        throw new Error("Parameter `taskReplace.destinationID` is required when calling `replaceTask`.");
      if (!r.action)
        throw new Error("Parameter `taskReplace.action` is required when calling `replaceTask`.");
      const i = {
        method: "PUT",
        path: "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Runs all tasks linked to a source, only available for Shopify, BigCommerce and commercetools sources. Creates one run per task.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param runSource - The runSource object.
     * @param runSource.sourceID - Unique identifier of a source.
     * @param runSource.runSourcePayload -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    runSource({ sourceID: e, runSourcePayload: r }, a) {
      if (!e)
        throw new Error("Parameter `sourceID` is required when calling `runSource`.");
      const i = {
        method: "POST",
        path: "/1/sources/{sourceID}/run".replace("{sourceID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r || {}
      };
      return t.request(i, a);
    },
    /**
     * Runs a task. You can check the status of task runs with the observability endpoints.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param runTask - The runTask object.
     * @param runTask.taskID - Unique identifier of a task.
     * @param runTask.runTaskPayload -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    runTask({ taskID: e, runTaskPayload: r }, a) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `runTask`.");
      const i = {
        method: "POST",
        path: "/2/tasks/{taskID}/run".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r || {}
      };
      return t.request(i, a);
    },
    /**
     * Runs a task using the v1 endpoint, please use `runTask` instead. You can check the status of task runs with the observability endpoints.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param runTaskV1 - The runTaskV1 object.
     * @param runTaskV1.taskID - Unique identifier of a task.
     * @param runTaskV1.runTaskPayload -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    runTaskV1({ taskID: e, runTaskPayload: r }, a) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `runTaskV1`.");
      const i = {
        method: "POST",
        path: "/1/tasks/{taskID}/run".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r || {}
      };
      return t.request(i, a);
    },
    /**
     * Searches for authentication resources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param authenticationSearch - The authenticationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchAuthentications(e, r) {
      if (!e)
        throw new Error("Parameter `authenticationSearch` is required when calling `searchAuthentications`.");
      if (!e.authenticationIDs)
        throw new Error(
          "Parameter `authenticationSearch.authenticationIDs` is required when calling `searchAuthentications`."
        );
      const n = {
        method: "POST",
        path: "/1/authentications/search",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Searches for destinations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param destinationSearch - The destinationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchDestinations(e, r) {
      if (!e)
        throw new Error("Parameter `destinationSearch` is required when calling `searchDestinations`.");
      if (!e.destinationIDs)
        throw new Error("Parameter `destinationSearch.destinationIDs` is required when calling `searchDestinations`.");
      const n = {
        method: "POST",
        path: "/1/destinations/search",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Searches for sources.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceSearch - The sourceSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchSources(e, r) {
      if (!e)
        throw new Error("Parameter `sourceSearch` is required when calling `searchSources`.");
      if (!e.sourceIDs)
        throw new Error("Parameter `sourceSearch.sourceIDs` is required when calling `searchSources`.");
      const n = {
        method: "POST",
        path: "/1/sources/search",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Searches for tasks.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param taskSearch - The taskSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchTasks(e, r) {
      if (!e)
        throw new Error("Parameter `taskSearch` is required when calling `searchTasks`.");
      if (!e.taskIDs)
        throw new Error("Parameter `taskSearch.taskIDs` is required when calling `searchTasks`.");
      const n = {
        method: "POST",
        path: "/2/tasks/search",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Searches for tasks using the v1 endpoint, please use `searchTasks` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param taskSearch - The taskSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchTasksV1(e, r) {
      if (!e)
        throw new Error("Parameter `taskSearch` is required when calling `searchTasksV1`.");
      if (!e.taskIDs)
        throw new Error("Parameter `taskSearch.taskIDs` is required when calling `searchTasksV1`.");
      const n = {
        method: "POST",
        path: "/1/tasks/search",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Searches for transformations.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param transformationSearch - The transformationSearch object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchTransformations(e, r) {
      if (!e)
        throw new Error("Parameter `transformationSearch` is required when calling `searchTransformations`.");
      if (!e.transformationIDs)
        throw new Error(
          "Parameter `transformationSearch.transformationIDs` is required when calling `searchTransformations`."
        );
      const n = {
        method: "POST",
        path: "/1/transformations/search",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Triggers a stream-listing request for a source. Triggering stream-listing requests only works with sources with `type: docker` and `imageType: airbyte`.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param triggerDockerSourceDiscover - The triggerDockerSourceDiscover object.
     * @param triggerDockerSourceDiscover.sourceID - Unique identifier of a source.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    triggerDockerSourceDiscover({ sourceID: e }, r) {
      if (!e)
        throw new Error("Parameter `sourceID` is required when calling `triggerDockerSourceDiscover`.");
      const n = {
        method: "POST",
        path: "/1/sources/{sourceID}/discover".replace("{sourceID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return r = {
        timeouts: {
          connect: 18e4,
          read: 18e4,
          write: 18e4,
          ...r == null ? void 0 : r.timeouts
        }
      }, t.request(n, r);
    },
    /**
     * Try a transformation before creating it.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param transformationTry - The transformationTry object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    tryTransformation(e, r) {
      if (!e)
        throw new Error("Parameter `transformationTry` is required when calling `tryTransformation`.");
      if (!e.sampleRecord)
        throw new Error("Parameter `transformationTry.sampleRecord` is required when calling `tryTransformation`.");
      const n = {
        method: "POST",
        path: "/1/transformations/try",
        queryParameters: {},
        headers: {},
        data: e
      };
      return t.request(n, r);
    },
    /**
     * Try a transformation before updating it.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param tryTransformationBeforeUpdate - The tryTransformationBeforeUpdate object.
     * @param tryTransformationBeforeUpdate.transformationID - Unique identifier of a transformation.
     * @param tryTransformationBeforeUpdate.transformationTry - The transformationTry object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    tryTransformationBeforeUpdate({ transformationID: e, transformationTry: r }, a) {
      if (!e)
        throw new Error("Parameter `transformationID` is required when calling `tryTransformationBeforeUpdate`.");
      if (!r)
        throw new Error("Parameter `transformationTry` is required when calling `tryTransformationBeforeUpdate`.");
      if (!r.sampleRecord)
        throw new Error(
          "Parameter `transformationTry.sampleRecord` is required when calling `tryTransformationBeforeUpdate`."
        );
      const i = {
        method: "POST",
        path: "/1/transformations/{transformationID}/try".replace(
          "{transformationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Updates an authentication resource.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateAuthentication - The updateAuthentication object.
     * @param updateAuthentication.authenticationID - Unique identifier of an authentication resource.
     * @param updateAuthentication.authenticationUpdate - The authenticationUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateAuthentication({ authenticationID: e, authenticationUpdate: r }, a) {
      if (!e)
        throw new Error("Parameter `authenticationID` is required when calling `updateAuthentication`.");
      if (!r)
        throw new Error("Parameter `authenticationUpdate` is required when calling `updateAuthentication`.");
      const i = {
        method: "PATCH",
        path: "/1/authentications/{authenticationID}".replace(
          "{authenticationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Updates the destination by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateDestination - The updateDestination object.
     * @param updateDestination.destinationID - Unique identifier of a destination.
     * @param updateDestination.destinationUpdate - The destinationUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateDestination({ destinationID: e, destinationUpdate: r }, a) {
      if (!e)
        throw new Error("Parameter `destinationID` is required when calling `updateDestination`.");
      if (!r)
        throw new Error("Parameter `destinationUpdate` is required when calling `updateDestination`.");
      const i = {
        method: "PATCH",
        path: "/1/destinations/{destinationID}".replace(
          "{destinationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Updates a source by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateSource - The updateSource object.
     * @param updateSource.sourceID - Unique identifier of a source.
     * @param updateSource.sourceUpdate - The sourceUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateSource({ sourceID: e, sourceUpdate: r }, a) {
      if (!e)
        throw new Error("Parameter `sourceID` is required when calling `updateSource`.");
      if (!r)
        throw new Error("Parameter `sourceUpdate` is required when calling `updateSource`.");
      const i = {
        method: "PATCH",
        path: "/1/sources/{sourceID}".replace("{sourceID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Partially updates a task by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateTask - The updateTask object.
     * @param updateTask.taskID - Unique identifier of a task.
     * @param updateTask.taskUpdate - The taskUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateTask({ taskID: e, taskUpdate: r }, a) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `updateTask`.");
      if (!r)
        throw new Error("Parameter `taskUpdate` is required when calling `updateTask`.");
      const i = {
        method: "PATCH",
        path: "/2/tasks/{taskID}".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Updates a task by its ID using the v1 endpoint, please use `updateTask` instead.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     *
     * @deprecated
     * @param updateTaskV1 - The updateTaskV1 object.
     * @param updateTaskV1.taskID - Unique identifier of a task.
     * @param updateTaskV1.taskUpdate - The taskUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateTaskV1({ taskID: e, taskUpdate: r }, a) {
      if (!e)
        throw new Error("Parameter `taskID` is required when calling `updateTaskV1`.");
      if (!r)
        throw new Error("Parameter `taskUpdate` is required when calling `updateTaskV1`.");
      const i = {
        method: "PATCH",
        path: "/1/tasks/{taskID}".replace("{taskID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Updates a transformation by its ID.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param updateTransformation - The updateTransformation object.
     * @param updateTransformation.transformationID - Unique identifier of a transformation.
     * @param updateTransformation.transformationCreate - The transformationCreate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    updateTransformation({ transformationID: e, transformationCreate: r }, a) {
      if (!e)
        throw new Error("Parameter `transformationID` is required when calling `updateTransformation`.");
      if (!r)
        throw new Error("Parameter `transformationCreate` is required when calling `updateTransformation`.");
      if (!r.name)
        throw new Error("Parameter `transformationCreate.name` is required when calling `updateTransformation`.");
      const i = {
        method: "PUT",
        path: "/1/transformations/{transformationID}".replace(
          "{transformationID}",
          encodeURIComponent(e)
        ),
        queryParameters: {},
        headers: {},
        data: r
      };
      return t.request(i, a);
    },
    /**
     * Validates a source payload to ensure it can be created and that the data source can be reached by Algolia.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param sourceCreate -
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    validateSource(e, r = void 0) {
      const n = {
        method: "POST",
        path: "/1/sources/validate",
        queryParameters: {},
        headers: {},
        data: e || {}
      };
      return r = {
        timeouts: {
          connect: 18e4,
          read: 18e4,
          write: 18e4,
          ...r == null ? void 0 : r.timeouts
        }
      }, t.request(n, r);
    },
    /**
     * Validates an update of a source payload to ensure it can be created and that the data source can be reached by Algolia.
     *
     * Required API Key ACLs:
     *  - addObject
     *  - deleteIndex
     *  - editSettings
     * @param validateSourceBeforeUpdate - The validateSourceBeforeUpdate object.
     * @param validateSourceBeforeUpdate.sourceID - Unique identifier of a source.
     * @param validateSourceBeforeUpdate.sourceUpdate - The sourceUpdate object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    validateSourceBeforeUpdate({ sourceID: e, sourceUpdate: r }, a) {
      if (!e)
        throw new Error("Parameter `sourceID` is required when calling `validateSourceBeforeUpdate`.");
      if (!r)
        throw new Error("Parameter `sourceUpdate` is required when calling `validateSourceBeforeUpdate`.");
      const i = {
        method: "POST",
        path: "/1/sources/{sourceID}/validate".replace("{sourceID}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r
      };
      return a = {
        timeouts: {
          connect: 18e4,
          read: 18e4,
          write: 18e4,
          ...a == null ? void 0 : a.timeouts
        }
      }, t.request(i, a);
    }
  };
}
function W(c, u, h, m) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  if (!h || h && (typeof h != "string" || !qe.includes(h)))
    throw new Error(`\`region\` is required and must be one of the following: ${qe.join(", ")}`);
  return br({
    appId: c,
    apiKey: u,
    region: h,
    timeouts: {
      connect: 25e3,
      read: 25e3,
      write: 25e3
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${Z}-${c}` }), E()]
    }),
    ...m
  });
}
const Ir = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apiClientVersion: Z,
  ingestionClient: W,
  isOnDemandTrigger: vr,
  isScheduleTrigger: Sr,
  isSubscriptionTrigger: Tr
}, Symbol.toStringTag, { value: "Module" }));
var ee = "1.44.0";
function Cr() {
  return [{ url: "status.algolia.com", accept: "readWrite", protocol: "https" }];
}
function Dr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  ...g
}) {
  const q = k(c, u, h), l = U({
    hosts: Cr(),
    ...g,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Monitoring",
      version: ee
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...q.headers(),
      ...g.baseHeaders
    },
    baseQueryParameters: {
      ...q.queryParameters(),
      ...g.baseQueryParameters
    }
  });
  return {
    transporter: l,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([l.requestsCache.clear(), l.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return l.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(t, e) {
      l.algoliaAgent.add({ segment: t, version: e });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: t }) {
      !h || h === "WithinHeaders" ? l.baseHeaders["x-algolia-api-key"] = t : l.baseQueryParameters["x-algolia-api-key"] = t;
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: t, parameters: e }, r) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const n = {
        method: "DELETE",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: t, parameters: e }, r) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const n = {
        method: "GET",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: t, parameters: e, body: r }, a) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const i = {
        method: "POST",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {},
        data: r || {}
      };
      return l.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: t, parameters: e, body: r }, a) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const i = {
        method: "PUT",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {},
        data: r || {}
      };
      return l.request(i, a);
    },
    /**
     * Retrieves known incidents for the selected clusters.
     * @param getClusterIncidents - The getClusterIncidents object.
     * @param getClusterIncidents.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getClusterIncidents({ clusters: t }, e) {
      if (!t)
        throw new Error("Parameter `clusters` is required when calling `getClusterIncidents`.");
      const o = {
        method: "GET",
        path: "/1/incidents/{clusters}".replace("{clusters}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Retrieves the status of selected clusters.
     * @param getClusterStatus - The getClusterStatus object.
     * @param getClusterStatus.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getClusterStatus({ clusters: t }, e) {
      if (!t)
        throw new Error("Parameter `clusters` is required when calling `getClusterStatus`.");
      const o = {
        method: "GET",
        path: "/1/status/{clusters}".replace("{clusters}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Retrieves known incidents for all clusters.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getIncidents(t) {
      const s = {
        method: "GET",
        path: "/1/incidents",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * Retrieves average times for indexing operations for selected clusters.
     * @param getIndexingTime - The getIndexingTime object.
     * @param getIndexingTime.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getIndexingTime({ clusters: t }, e) {
      if (!t)
        throw new Error("Parameter `clusters` is required when calling `getIndexingTime`.");
      const o = {
        method: "GET",
        path: "/1/indexing/{clusters}".replace("{clusters}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Retrieves the average latency for search requests for selected clusters.
     * @param getLatency - The getLatency object.
     * @param getLatency.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getLatency({ clusters: t }, e) {
      if (!t)
        throw new Error("Parameter `clusters` is required when calling `getLatency`.");
      const o = {
        method: "GET",
        path: "/1/latency/{clusters}".replace("{clusters}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Retrieves metrics related to your Algolia infrastructure, aggregated over a selected time window.  Access to this API is available as part of the [Premium or Elevate plans](https://www.algolia.com/pricing). You must authenticate requests with the `x-algolia-application-id` and `x-algolia-api-key` headers (using the Monitoring API key).
     * @param getMetrics - The getMetrics object.
     * @param getMetrics.metric - Metric to report.  For more information about the individual metrics, see the description of the API response. To include all metrics, use `*`.
     * @param getMetrics.period - Period over which to aggregate the metrics:  - `minute`. Aggregate the last minute. 1 data point per 10 seconds. - `hour`. Aggregate the last hour. 1 data point per minute. - `day`. Aggregate the last day. 1 data point per 10 minutes. - `week`. Aggregate the last week. 1 data point per hour. - `month`. Aggregate the last month. 1 data point per day.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getMetrics({ metric: t, period: e }, r) {
      if (!t)
        throw new Error("Parameter `metric` is required when calling `getMetrics`.");
      if (!e)
        throw new Error("Parameter `period` is required when calling `getMetrics`.");
      const n = {
        method: "GET",
        path: "/1/infrastructure/{metric}/period/{period}".replace("{metric}", encodeURIComponent(t)).replace("{period}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * Test whether clusters are reachable or not.
     * @param getReachability - The getReachability object.
     * @param getReachability.clusters - Subset of clusters, separated by commas.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getReachability({ clusters: t }, e) {
      if (!t)
        throw new Error("Parameter `clusters` is required when calling `getReachability`.");
      const o = {
        method: "GET",
        path: "/1/reachability/{clusters}/probes".replace("{clusters}", encodeURIComponent(t)),
        queryParameters: {},
        headers: {}
      };
      return l.request(o, e);
    },
    /**
     * Retrieves the servers that belong to clusters.  The response depends on whether you authenticate your API request:  - With authentication, the response lists the servers assigned to your Algolia application\'s cluster.  - Without authentication, the response lists the servers for all Algolia clusters.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getServers(t) {
      const s = {
        method: "GET",
        path: "/1/inventory/servers",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    },
    /**
     * Retrieves the status of all Algolia clusters and instances.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getStatus(t) {
      const s = {
        method: "GET",
        path: "/1/status",
        queryParameters: {},
        headers: {}
      };
      return l.request(s, t);
    }
  };
}
function Ie(c, u, h) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  return Dr({
    appId: c,
    apiKey: u,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${ee}-${c}` }), E()]
    }),
    ...h
  });
}
const Rr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apiClientVersion: ee,
  monitoringClient: Ie
}, Symbol.toStringTag, { value: "Module" }));
var re = "5.44.0";
function kr(c) {
  return [
    {
      url: `${c}-dsn.algolia.net`,
      accept: "read",
      protocol: "https"
    },
    {
      url: `${c}.algolia.net`,
      accept: "write",
      protocol: "https"
    }
  ].concat(
    we([
      {
        url: `${c}-1.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${c}-2.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      },
      {
        url: `${c}-3.algolianet.com`,
        accept: "readWrite",
        protocol: "https"
      }
    ])
  );
}
function xr({
  appId: c,
  apiKey: u,
  authMode: h,
  algoliaAgents: m,
  ...g
}) {
  const q = k(c, u, h), l = U({
    hosts: kr(c),
    ...g,
    algoliaAgent: x({
      algoliaAgents: m,
      client: "Recommend",
      version: re
    }),
    baseHeaders: {
      "content-type": "text/plain",
      ...q.headers(),
      ...g.baseHeaders
    },
    baseQueryParameters: {
      ...q.queryParameters(),
      ...g.baseQueryParameters
    }
  });
  return {
    transporter: l,
    /**
     * The `appId` currently in use.
     */
    appId: c,
    /**
     * The `apiKey` currently in use.
     */
    apiKey: u,
    /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */
    clearCache() {
      return Promise.all([l.requestsCache.clear(), l.responsesCache.clear()]).then(() => {
      });
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return l.algoliaAgent.value;
    },
    /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */
    addAlgoliaAgent(t, e) {
      l.algoliaAgent.add({ segment: t, version: e });
    },
    /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */
    setClientApiKey({ apiKey: t }) {
      !h || h === "WithinHeaders" ? l.baseHeaders["x-algolia-api-key"] = t : l.baseQueryParameters["x-algolia-api-key"] = t;
    },
    /**
     * Create or update a batch of Recommend Rules  Each Recommend Rule is created or updated, depending on whether a Recommend Rule with the same `objectID` already exists. You may also specify `true` for `clearExistingRules`, in which case the batch will atomically replace all the existing Recommend Rules.  Recommend Rules are similar to Search Rules, except that the conditions and consequences apply to a [source item](/doc/guides/algolia-recommend/overview/#recommend-models) instead of a query. The main differences are the following: - Conditions `pattern` and `anchoring` are unavailable. - Condition `filters` triggers if the source item matches the specified filters. - Condition `filters` accepts numeric filters. - Consequence `params` only covers filtering parameters. - Consequence `automaticFacetFilters` doesn\'t require a facet value placeholder (it tries to match the data source item\'s attributes instead).
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param batchRecommendRules - The batchRecommendRules object.
     * @param batchRecommendRules.indexName - Name of the index on which to perform the operation.
     * @param batchRecommendRules.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param batchRecommendRules.recommendRule - The recommendRule object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    batchRecommendRules({ indexName: t, model: e, recommendRule: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `batchRecommendRules`.");
      if (!e)
        throw new Error("Parameter `model` is required when calling `batchRecommendRules`.");
      const i = {
        method: "POST",
        path: "/1/indexes/{indexName}/{model}/recommend/rules/batch".replace("{indexName}", encodeURIComponent(t)).replace("{model}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r || {}
      };
      return l.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customDelete - The customDelete object.
     * @param customDelete.path - Path of the endpoint, for example `1/newFeature`.
     * @param customDelete.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customDelete({ path: t, parameters: e }, r) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customDelete`.");
      const n = {
        method: "DELETE",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customGet - The customGet object.
     * @param customGet.path - Path of the endpoint, for example `1/newFeature`.
     * @param customGet.parameters - Query parameters to apply to the current query.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customGet({ path: t, parameters: e }, r) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customGet`.");
      const n = {
        method: "GET",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {}
      };
      return l.request(n, r);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPost({ path: t, parameters: e, body: r }, a) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customPost`.");
      const i = {
        method: "POST",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {},
        data: r || {}
      };
      return l.request(i, a);
    },
    /**
     * This method lets you send requests to the Algolia REST API.
     * @param customPut - The customPut object.
     * @param customPut.path - Path of the endpoint, for example `1/newFeature`.
     * @param customPut.parameters - Query parameters to apply to the current query.
     * @param customPut.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    customPut({ path: t, parameters: e, body: r }, a) {
      if (!t)
        throw new Error("Parameter `path` is required when calling `customPut`.");
      const i = {
        method: "PUT",
        path: "/{path}".replace("{path}", t),
        queryParameters: e || {},
        headers: {},
        data: r || {}
      };
      return l.request(i, a);
    },
    /**
     * Deletes a Recommend rule from a recommendation scenario.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param deleteRecommendRule - The deleteRecommendRule object.
     * @param deleteRecommendRule.indexName - Name of the index on which to perform the operation.
     * @param deleteRecommendRule.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param deleteRecommendRule.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    deleteRecommendRule({ indexName: t, model: e, objectID: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `deleteRecommendRule`.");
      if (!e)
        throw new Error("Parameter `model` is required when calling `deleteRecommendRule`.");
      if (!r)
        throw new Error("Parameter `objectID` is required when calling `deleteRecommendRule`.");
      const i = {
        method: "DELETE",
        path: "/1/indexes/{indexName}/{model}/recommend/rules/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{model}", encodeURIComponent(e)).replace("{objectID}", encodeURIComponent(r)),
        queryParameters: {},
        headers: {}
      };
      return l.request(i, a);
    },
    /**
     * Retrieves a Recommend rule that you previously created in the Algolia dashboard.
     *
     * Required API Key ACLs:
     *  - settings
     * @param getRecommendRule - The getRecommendRule object.
     * @param getRecommendRule.indexName - Name of the index on which to perform the operation.
     * @param getRecommendRule.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param getRecommendRule.objectID - Unique record identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRecommendRule({ indexName: t, model: e, objectID: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `getRecommendRule`.");
      if (!e)
        throw new Error("Parameter `model` is required when calling `getRecommendRule`.");
      if (!r)
        throw new Error("Parameter `objectID` is required when calling `getRecommendRule`.");
      const i = {
        method: "GET",
        path: "/1/indexes/{indexName}/{model}/recommend/rules/{objectID}".replace("{indexName}", encodeURIComponent(t)).replace("{model}", encodeURIComponent(e)).replace("{objectID}", encodeURIComponent(r)),
        queryParameters: {},
        headers: {}
      };
      return l.request(i, a);
    },
    /**
     * Checks the status of a given task.  Deleting a Recommend rule is asynchronous. When you delete a rule, a task is created on a queue and completed depending on the load on the server. The API response includes a task ID that you can use to check the status.
     *
     * Required API Key ACLs:
     *  - editSettings
     * @param getRecommendStatus - The getRecommendStatus object.
     * @param getRecommendStatus.indexName - Name of the index on which to perform the operation.
     * @param getRecommendStatus.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param getRecommendStatus.taskID - Unique task identifier.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRecommendStatus({ indexName: t, model: e, taskID: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `getRecommendStatus`.");
      if (!e)
        throw new Error("Parameter `model` is required when calling `getRecommendStatus`.");
      if (!r)
        throw new Error("Parameter `taskID` is required when calling `getRecommendStatus`.");
      const i = {
        method: "GET",
        path: "/1/indexes/{indexName}/{model}/task/{taskID}".replace("{indexName}", encodeURIComponent(t)).replace("{model}", encodeURIComponent(e)).replace("{taskID}", encodeURIComponent(r)),
        queryParameters: {},
        headers: {}
      };
      return l.request(i, a);
    },
    /**
     * Retrieves recommendations from selected AI models.
     *
     * Required API Key ACLs:
     *  - search
     * @param getRecommendationsParams - The getRecommendationsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    getRecommendations(t, e) {
      if (t && Array.isArray(t) && (t = {
        requests: t
      }), !t)
        throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
      if (!t.requests)
        throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
      const o = {
        method: "POST",
        path: "/1/indexes/*/recommendations",
        queryParameters: {},
        headers: {},
        data: t,
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(o, e);
    },
    /**
     * Searches for Recommend rules.  Use an empty query to list all rules for this recommendation scenario.
     *
     * Required API Key ACLs:
     *  - settings
     * @param searchRecommendRules - The searchRecommendRules object.
     * @param searchRecommendRules.indexName - Name of the index on which to perform the operation.
     * @param searchRecommendRules.model - [Recommend model](https://www.algolia.com/doc/guides/algolia-recommend/overview/#recommend-models).
     * @param searchRecommendRules.searchRecommendRulesParams - The searchRecommendRulesParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */
    searchRecommendRules({ indexName: t, model: e, searchRecommendRulesParams: r }, a) {
      if (!t)
        throw new Error("Parameter `indexName` is required when calling `searchRecommendRules`.");
      if (!e)
        throw new Error("Parameter `model` is required when calling `searchRecommendRules`.");
      const i = {
        method: "POST",
        path: "/1/indexes/{indexName}/{model}/recommend/rules/search".replace("{indexName}", encodeURIComponent(t)).replace("{model}", encodeURIComponent(e)),
        queryParameters: {},
        headers: {},
        data: r || {},
        useReadTransporter: !0,
        cacheable: !0
      };
      return l.request(i, a);
    }
  };
}
function Ce(c, u, h) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  return xr({
    appId: c,
    apiKey: u,
    timeouts: {
      connect: 1e3,
      read: 2e3,
      write: 3e4
    },
    logger: A(),
    requester: D(),
    algoliaAgents: [{ segment: "Browser" }],
    authMode: "WithinQueryParameters",
    responsesCache: E(),
    requestsCache: E({ serializable: !1 }),
    hostsCache: b({
      caches: [R({ key: `${re}-${c}` }), E()]
    }),
    ...h
  });
}
const Ar = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  apiClientVersion: re,
  recommendClient: Ce
}, Symbol.toStringTag, { value: "Module" }));
var De = Object.defineProperty, Ur = Object.getOwnPropertyDescriptor, Nr = Object.getOwnPropertyNames, jr = Object.prototype.hasOwnProperty, Re = (c, u) => {
  for (var h in u)
    De(c, h, { get: u[h], enumerable: !0 });
}, Gr = (c, u, h, m) => {
  if (u && typeof u == "object" || typeof u == "function")
    for (let g of Nr(u))
      !jr.call(c, g) && g !== h && De(c, g, { get: () => u[g], enumerable: !(m = Ur(u, g)) || m.enumerable });
  return c;
}, C = (c, u, h) => (Gr(c, u, "default"), h), ke = {};
Re(ke, {
  algoliasearch: () => xe,
  apiClientVersion: () => B
});
var I = {};
Re(I, {
  apiClientVersion: () => B
});
C(I, tr);
C(I, nr);
C(I, ur);
C(I, dr);
C(I, qr);
C(I, wr);
C(I, yr);
C(I, Ir);
C(I, Rr);
C(I, Ar);
C(ke, I);
function xe(c, u, h) {
  if (!c || typeof c != "string")
    throw new Error("`appId` is missing.");
  if (!u || typeof u != "string")
    throw new Error("`apiKey` is missing.");
  const m = be(c, u, h);
  let g;
  if (h != null && h.transformation) {
    if (!h.transformation.region)
      throw new Error("`region` must be provided when leveraging the transformation pipeline");
    g = W(c, u, h.transformation.region, h);
  }
  return {
    ...m,
    async saveObjectsWithTransformation({ indexName: q, objects: l, waitForTasks: t }, e) {
      var r;
      if (!g)
        throw new Error("`transformation.region` must be provided at client instantiation before calling this method.");
      if (!((r = h == null ? void 0 : h.transformation) != null && r.region))
        throw new Error("`region` must be provided when leveraging the transformation pipeline");
      return g.chunkedPush(
        { indexName: q, objects: l, action: "addObject", waitForTasks: t },
        e
      );
    },
    async partialUpdateObjectsWithTransformation({ indexName: q, objects: l, createIfNotExists: t, waitForTasks: e }, r) {
      var a;
      if (!g)
        throw new Error("`transformation.region` must be provided at client instantiation before calling this method.");
      if (!((a = h == null ? void 0 : h.transformation) != null && a.region))
        throw new Error("`region` must be provided when leveraging the transformation pipeline");
      return g.chunkedPush(
        {
          indexName: q,
          objects: l,
          action: t ? "partialUpdateObject" : "partialUpdateObjectNoCreate",
          waitForTasks: e
        },
        r
      );
    },
    async replaceAllObjectsWithTransformation({ indexName: q, objects: l, batchSize: t, scopes: e }, r) {
      var o;
      if (!g)
        throw new Error("`transformation.region` must be provided at client instantiation before calling this method.");
      if (!((o = h == null ? void 0 : h.transformation) != null && o.region))
        throw new Error("`region` must be provided when leveraging the transformation pipeline");
      const a = Math.floor(Math.random() * 1e6) + 1e5, s = `${q}_tmp_${a}`;
      e === void 0 && (e = ["settings", "rules", "synonyms"]);
      try {
        let n = await this.operationIndex(
          {
            indexName: q,
            operationIndexParams: {
              operation: "copy",
              destination: s,
              scope: e
            }
          },
          r
        );
        const i = await g.chunkedPush(
          { indexName: s, objects: l, waitForTasks: !0, batchSize: t, referenceIndexName: q },
          r
        );
        await this.waitForTask({
          indexName: s,
          taskID: n.taskID
        }), n = await this.operationIndex(
          {
            indexName: q,
            operationIndexParams: {
              operation: "copy",
              destination: s,
              scope: e
            }
          },
          r
        ), await this.waitForTask({
          indexName: s,
          taskID: n.taskID
        });
        const d = await this.operationIndex(
          {
            indexName: s,
            operationIndexParams: { operation: "move", destination: q }
          },
          r
        );
        return await this.waitForTask({
          indexName: s,
          taskID: d.taskID
        }), { copyOperationResponse: n, watchResponses: i, moveOperationResponse: d };
      } catch (n) {
        throw await this.deleteIndex({ indexName: s }), n;
      }
    },
    /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */
    get _ua() {
      return m.transporter.algoliaAgent.value;
    },
    initAbtesting: (q) => ye(
      q.appId || c,
      q.apiKey || u,
      q.region,
      q.options
    ),
    initAbtestingV3: (q) => pe(
      q.appId || c,
      q.apiKey || u,
      q.region,
      q.options
    ),
    initAnalytics: (q) => Ee(
      q.appId || c,
      q.apiKey || u,
      q.region,
      q.options
    ),
    initIngestion: (q) => W(
      q.appId || c,
      q.apiKey || u,
      q.region,
      q.options
    ),
    initInsights: (q) => ve(
      q.appId || c,
      q.apiKey || u,
      q.region,
      q.options
    ),
    initMonitoring: (q = {}) => Ie(q.appId || c, q.apiKey || u, q.options),
    initPersonalization: (q) => Se(
      q.appId || c,
      q.apiKey || u,
      q.region,
      q.options
    ),
    initQuerySuggestions: (q) => Te(
      q.appId || c,
      q.apiKey || u,
      q.region,
      q.options
    ),
    initRecommend: (q = {}) => Ce(q.appId || c, q.apiKey || u, q.options)
  };
}
const te = class te extends HTMLElement {
  constructor() {
    var u, h;
    super(), this.productsByRef = [], this.algoliaConfig = null, this.algoliaClient = null, this.renderIcon = Ne, this.renderSuggestion = je, this.form = this.querySelector("form"), this.input = (u = this.form) == null ? void 0 : u.querySelector(
      'input[type="search"]'
    ), this.clear = (h = this.form) == null ? void 0 : h.querySelector(
      'button[type="reset"]'
    ), this.nonProductResults = null, this.suggestions = this.querySelector("#SearchSuggestions"), this.productSuggestions = this.querySelector(
      "#ProductSuggestions"
    ), this.viewAll = this.querySelector("[data-view-all]"), this.algoliaSetup(), this.handleSubmitDebounced = Ge(
      this.handleSubmit,
      _e
    );
  }
  connectedCallback() {
    !this.form || !this.input || (this.form.addEventListener("input", (u) => {
      u.preventDefault(), this.handleSubmitDebounced(u);
    }), this.form.addEventListener("reset", () => {
      this.handleClear();
    }), this.viewAll && this.viewAll.addEventListener("click", (u) => {
      var h;
      u.preventDefault(), (h = this.form) == null || h.submit();
    }), this.clear && this.clear.addEventListener("click", (u) => {
      u.preventDefault(), this.handleReset();
    }));
  }
  attributeChangedCallback(u) {
    (u === "data-product-count" || u === "data-content-count") && this.updateState();
  }
  handleSubmit() {
    if (!(!this.form || !this.input)) {
      if (!this.input.value || this.input.value.length < 3) {
        this.handleClear();
        return;
      }
      console.log("Searching for:", this.input.value), this.search(this.input.value), this.searchProducts(this.input.value), this.searchProductsByRef(this.input.value);
    }
  }
  handleClear() {
    !this.suggestions || !this.productSuggestions || (this.suggestions.innerHTML = "", this.productSuggestions.innerHTML = "", this.dataset.contentCount = "0", this.dataset.productCount = "0");
  }
  handleReset() {
    this.handleClear(), this.input && this.input.value !== "" && (this.input.value = ""), setTimeout(() => {
      var u;
      (u = this.input) == null || u.focus();
    }, 100), this.updateState();
  }
  search(u) {
    fetch(`https://search.watchesofswitzerland.com/?q=${u}`, {
      method: "GET"
    }).then((h) => h.json()).then((h) => {
      var m;
      h && (this.nonProductResults = (m = h == null ? void 0 : h.result) == null ? void 0 : m.results, this.renderSuggestions());
    }).catch((h) => {
      console.error("Error fetching search results:", h);
    });
  }
  renderSuggestions() {
    if (!this.suggestions || !this.nonProductResults)
      return;
    if (this.dataset.contentCount = this.nonProductResults.hits.length.toString(), this.nonProductResults.hits.length === 0) {
      this.suggestions.innerHTML = "";
      return;
    }
    const u = this.nonProductResults.hits.slice(0, 6);
    let h = "";
    u.forEach((m) => {
      h += this.renderSuggestion(m.document);
    }), this.suggestions.innerHTML = h;
  }
  searchProducts(u) {
    fetch(`/search?q=${u}&section_id=search-suggestions`).then((h) => h.text()).then((h) => {
      if (h) {
        const g = new DOMParser().parseFromString(h, "text/html").querySelector(
          "#SearchSuggestionProducts"
        ), q = this.querySelector(
          "#SearchSuggestionProducts"
        ), l = g.dataset.productCount;
        q && g && (q.innerHTML = g.innerHTML || "", this.dataset.productCount = l || "0");
      }
    }).catch((h) => {
      console.error("Error fetching search results:", h);
    });
  }
  algoliaSetup() {
    this.algoliaConfig = window.__VENDORS__.algolia || {
      enabled: !1,
      appId: "JJJFXPJ5MS",
      searchKey: "4289e860cd86a4e3e1816a0ac2ae6d03",
      indexName: "shopify_products"
    }, !(!this.algoliaConfig.enabled || !this.algoliaConfig.appId || !this.algoliaConfig.searchKey) && (this.algoliaClient = xe(
      this.algoliaConfig.appId,
      this.algoliaConfig.searchKey
    ));
  }
  async searchProductsByRef(u) {
    var g;
    if (!((g = this.algoliaConfig) != null && g.enabled) || !this.algoliaClient)
      return;
    const h = await this.algoliaClient.searchSingleIndex({
      indexName: this.algoliaConfig.indexName,
      searchParams: {
        query: u,
        hitsPerPage: 6,
        restrictSearchableAttributes: ["meta.custom.reference"],
        getRankingInfo: !0,
        disableTypoToleranceOnAttributes: ["meta.custom.reference"]
      }
    });
    if (!h.hits.length) {
      this.productsByRef = [], this.renderProductsByRef(), this.dataset.productSearchType = "default";
      return;
    }
    const m = h.hits;
    this.productsByRef = m, this.dataset.productCount = m.length.toString(), this.dataset.productSearchType = "reference", this.renderProductsByRef();
  }
  renderProductsByRef() {
    const u = this.productsByRef.map((m) => {
      let g = m.image;
      return g && (window.location.hostname.includes("shopify") || (g = Oe(g)), g = g + "&width=200&height=200"), `
        <li
          class='text-brand-darkest'
          data-ref='${m.handle}'
        >
          <a
            href='/products/${m.handle}'
            class='grid grid-cols-[100px_1fr] gap-4 place-items-center focus-visible:outline-brand-focus hover:opacity-90 transition-opacity'
          >
            <div class='bg-brand-lighter aspect-square w-full rounded-sm'>
              ${g ? `<img src='${g}' width='200' height='200' alt='${m.title}' loading='lazy' class='mix-blend-multiply aspect-square rounded-sm'>` : ""}
            </div>
            <div class='flex items-start flex-col justify-start w-full text-brand-darkest relative'>
              <p class='utility-mini uppercase mb-2.5'>${m.meta.custom.reference}</p>
              <p class='utility-mini uppercase mb-2.5'>${m.vendor}</p>
              <h4 class='text-base line-clamp-2 leading-[1.3]'>${m.title}</h4>
            </div>
          </a>
        </li>
      `;
    }).join(""), h = this.querySelector(
      "#SearchSuggestionProductsByRef"
    );
    h && (h.innerHTML = u);
  }
  updateState() {
    if (this.dataset.productCount === "" || this.dataset.contentCount === "") {
      this.dataset.results = "ready";
      return;
    }
    this.dataset.productCount === "0" && this.dataset.contentCount === "0" ? this.dataset.results = this.input && this.input.value.length > 2 ? "none" : "ready" : this.dataset.results = "some";
  }
};
te.observedAttributes = ["data-product-count", "data-content-count"];
let Q = te;
window.customElements.define("search-suggestions", Q);
export {
  Q as SearchSuggestions
};
